$(document).ready(function() {
'use strict';

$('.order--container').on('click', function () {
  if ($(this).hasClass('follow__link') == false) {
    var orderId = $(this).attr('order-id');
    $('.order__details[order-id="' + orderId + '"]').slideToggle(200).toggleClass('is-active');
    $(this).toggleClass('child-active');
    $(this).children('.open__line__items--link').children().toggleClass('arrow--top arrow--bottom');
  }
});

$('#reset-password').click(function () {
  $('#login').css('display', 'none');
  $('#reset').fadeIn("slow");
});
'use strict';

$('#accordion-navigation .plus__icon').show();
$('#accordion-navigation').find('li.extend').click(function (e) {
  $(this).children('.extended-submenu').slideToggle('fast');
  $(this).children('.nav--title').children('.plus__icon').toggleClass('opened');
  $(this).toggleClass('active');
});
"use strict";

// Si le client veut la formule RGPD
// --> on supprime ce qui est non commente
// --> on decommente le reste

$(".button--cookie").click(function () {
  $("#cookie--banner").hide();
  $('#page__overlay--cookie').removeClass("opened");
});

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

if (getCookie('cookies-accepted') == 'yes') {} else {
  $("#cookie--banner").addClass("apparition--cookie");
  $('#page__overlay--cookie').addClass("opened");
}

$('#accept--all, #reject--all').on('click', function () {
  var CookieDate = new Date();
  CookieDate.setMonth(CookieDate.getMonth() + 12);
  document.cookie = "cookies-accepted=yes; expires=" + CookieDate.toGMTString() + "; path=/";
});

// window.Shopify.loadFeatures([
//   {
//     name: 'consent-tracking-api',
//     version: '0.1',
//   },
// ], function (error) {
//   if (error) {
//     throw error;
//   }
//   const showBanner = window.Shopify.customerPrivacy.shouldShowGDPRBanner();

//   if (showBanner == true) {
//     setTimeout(function(){
//       $("#cookie--banner").addClass( "apparition--cookie" );
//       $('#page__overlay--cookie').addClass("opened");
//     }, 1000);
//   } else {
//     if (window.Shopify.customerPrivacy.userCanBeTracked()) {
//       document.dispatchEvent(new CustomEvent('trackingConsentAccepted'));
//     }
//   }
// });

// $('#accept--all').on('click', function() {
//   window.Shopify.customerPrivacy.setTrackingConsent(true, function() {
//     $("#cookie--banner").hide();
//     $('#page__overlay--cookie').removeClass("opened");
//   });
// })

// $('#reject--all').on('click', function() {
//   window.Shopify.customerPrivacy.setTrackingConsent(false, function() {
//     $("#cookie--banner").hide();
//     $('#page__overlay--cookie').removeClass("opened");
//   });
// })

// document.addEventListener('trackingConsentAccepted', function (e) {
//   console.log('tracking accepted')
// }, false);
'use strict';

document.addEventListener('cart:open', function (elem) {
  if (window.cart.cartType == 'preview') {
    $('#cart__preview').addClass('opened--added-to-cart');
    $('.link--text-style--cart').addClass('link__active');

    if (window.matchMedia("(max-width: 1100px)").matches) {
      $('#page__overlay--navigation').addClass('opened');
    } else {
      setTimeout(function () {
        $('#cart__preview').removeClass('opened--added-to-cart');
        if ($('#cart__preview').hasClass('opened') == false) {
          $('.link--text-style--cart').removeClass('link__active');
        }
      }, 4000);
    }
  } else {
    $("#cart__drawer").addClass('opened');
    $('#page__overlay').addClass('opened');
    $('#page__overlay').attr('for', 'drawer');
    setTimeout(function () {
      $('#drawer__cart--exta-infos').addClass('opened');
    }, 350);
  }
}, false);

var updateDeliveryModule = function updateDeliveryModule(total) {
  if (window.cart.deliveryModule) {
    var deliveryLimit = window.cart.freeDelivery - 1;
    var remainPercentage = Math.max(0, (deliveryLimit - total) / deliveryLimit * 100);
    var remainMoney = Math.max(0, (deliveryLimit + 1 - total) / 100);
    var colorBar = 100 - remainPercentage;

    $('#progress__bar--remain').css('width', colorBar + '%');

    if (remainMoney > 0) {
      $('#free__shipping--message').hide();
      $('#remain__shipping__amount--message').show();
      $('.amount__remaining').text(remainMoney + "€");
    } else {
      $('#free__shipping--message').show();
      $('#remain__shipping__amount--message').hide();
    }
  }
};
'use strict';

if (window.matchMedia("(min-width: 1101px)").matches) {
  $('.button__action--cart-preview').mouseenter(function (e) {
    $('#cart__preview').addClass('opened');
    handleNavbarHover("opened");
  });

  $('#cart__preview').mouseenter(function (e) {
    $('#cart__preview').addClass('opened');
    handleNavbarHover("opened");
  });

  $('#cart__preview').mouseleave(function (e) {
    $('#cart__preview').removeClass('opened');
    $('#cart__preview').removeClass('opened--added-to-cart');

    $('.link--text-style--cart').removeClass('link__active');
    if ($(e.relatedTarget).is('.link--text-style')) {} else {
      handleNavbarHover("closed");
    }
  });

  $('.button__action--cart-preview').mouseleave(function (e) {
    $('#cart__preview').removeClass('opened');
    $('#cart__preview').removeClass('opened--added-to-cart');

    $('.link--text-style--cart').removeClass('link__active');
    if ($(e.relatedTarget).is('.links__container--half, #navigation__links--list, .link--text-style, .announcement__bar--container')) {} else {
      handleNavbarHover("closed");
    }
  });
} else {
  $('.button__action--cart-preview').on('click', function () {
    if ($('#cart__preview').hasClass('opened')) {
      $('#cart__preview').removeClass('opened');
      $('#cart__preview').removeClass('opened--added-to-cart');
      $('#page__overlay--navigation').removeClass('opened');
      handleNavbarHover("closed");
    } else {
      $('#cart__preview').addClass('opened');
      //$('#page__overlay--navigation').addClass('opened');
      handleNavbarHover("opened");
    }
  });

  $('.close--cart-preview').on('click', function () {
    $('#cart__preview').removeClass('opened opened--added-to-cart');
    $('#cart__preview').removeClass('opened--added-to-cart');
    $('#page__overlay--navigation').removeClass('opened');
    handleNavbarHover("closed");
  });

  $('#page__overlay--navigation').on('click', function () {
    $('#cart__preview').removeClass('opened opened--added-to-cart');
    $('#cart__preview').removeClass('opened--added-to-cart');
    $('#page__overlay--navigation').removeClass('opened');
    handleNavbarHover("closed");
    $('.search--container').removeClass('opened, opened-scroll, opened-mobile, opened-mobile-scroll, opened-mobile2, opened-blog');
  });
}

if ($(document).scrollTop() > 20) {
  $("#cart__preview").css('top', '48px');
}

$(document).on('scroll', function () {
  if ($(document).scrollTop() > 20) {
    $("#cart__preview").css('top', '48px');
  } else {
    $("#cart__preview").css('top', '85px');
  }
});

function handleNavbarHover(status) {
  if (window.location.pathname == "/") {
    /*if (window.matchMedia("(min-width: 1101px)").matches) {
      if (status == "opened") {
        $('.link--text-style--cart').addClass('link__active');
        $('#navigation--container').removeClass('transparent--nav');
        $('#main__logo--svg').removeClass('logo--white');
      } else {
        $('#navigation--container').addClass('transparent--nav');
        $('#main__logo--svg').addClass('logo--white');
      }
    }*/
  }
}
'use strict';

// Add to cart funnction
if (window.location.pathname == "/cart") {
  window.cart.drawer = false;
}

$('body').on('click', '.add__to__cart', function (e) {
  e.preventDefault();
  var variantId = $(this).attr('variant-id');
  var available = $(this).attr('variant-available');
  var productHandle = $(this).attr('data-product-handle');
  var productId = $(this).attr('data-product-id');
  var productType = $(this).attr('data-product-type');
  var productTitle = $(this).attr('data-product-title');
  var productPrice = $(this).attr('data-product-price');
  var variants = $(this).attr('variants');
  var type = $(this).attr('button-type');
  var $this = $(this);

  if (available == 'true' || available == true) {
    $this.children('.button--text').css('display', 'none');
    $this.children('.button--loading').css('display', 'block');

    if (variantId) {
      var qty = 1;
      if (type == 'product') {
        qty = $('.product__qty--container .quantity__current').val();
      }
      var objUpdate = { quantity: qty, id: variantId, properties: {} };

      if ($(this).hasClass('giftCard')) {
        var mail = $('#recipient-mail-destinataire').val();
        var name = $('#recipient-name').val();
        var message = $('#recipient-message').val();
        var date = $('#recipient-date').val();

        var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

        if (!mail) {
          $('.error-mail').show();
          setTimeout(function () {
            $('.error-mail').hide();
          }, 2000);
          $this.children('.button--loading').css('display', 'none');

          if (window.matchMedia("(max-width: 767px)").matches) {
            $this.children('.button--text.hidden__desktop').css('display', 'block');
          } else {
            $this.children('.button--text.hidden__phone').css('display', 'block');
          }
          return;
        } else if (!emailRegex.test(mail)) {
          $('.error-mail-mail').show();
          setTimeout(function () {
            $('.error-mail-mail').hide();
          }, 2000);
          $this.children('.button--loading').css('display', 'none');

          if (window.matchMedia("(max-width: 767px)").matches) {
            $this.children('.button--text.hidden__desktop').css('display', 'block');
          } else {
            $this.children('.button--text.hidden__phone').css('display', 'block');
          }
          return;
        } else if (!name) {
          $('.error-name').show();
          setTimeout(function () {
            $('.error-name').hide();
          }, 2000);
          $this.children('.button--loading').css('display', 'none');

          if (window.matchMedia("(max-width: 767px)").matches) {
            $this.children('.button--text.hidden__desktop').css('display', 'block');
          } else {
            $this.children('.button--text.hidden__phone').css('display', 'block');
          }
          return;
        } else if (!date) {
          $('.error-date').show();
          setTimeout(function () {
            $('.error-date').hide();
          }, 2000);
          $this.children('.button--loading').css('display', 'none');

          if (window.matchMedia("(max-width: 767px)").matches) {
            $this.children('.button--text.hidden__desktop').css('display', 'block');
          } else {
            $this.children('.button--text.hidden__phone').css('display', 'block');
          }
          return;
        }

        objUpdate.properties = {
          __shopify_send_gift_card_to_recipient: true,
          'Recipient email': mail,
          'Recipient name': name,
          Message: message,
          'Send on': date
        };
      }
      console.log(objUpdate);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: objUpdate,
        dataType: 'json',
        success: function success(response) {
          updateCartData();
          document.dispatchEvent(new CustomEvent('update-reco-drawer'));
          document.dispatchEvent(new CustomEvent('product:added'));
          if (window.dataLayer) {
            window.dataLayer.push({
              "event": "addToCart",
              "productName": productTitle || "",
              "productHandle": productHandle || "",
              "productType": productType || "",
              "productID": productId || "",
              "variantID": variantId || "",
              "productPrice": response.price / 100,
              "quantity": 1
            });
          }

          if ($('#empty__cart--title').length > 0) {
            location.reload(true);
          }

          document.dispatchEvent(new CustomEvent('cart:open'));
          $this.children('.button--text').css('display', 'block');
          $this.children('.button--loading').css('display', 'none');
        },
        error: function error(_error) {
          console.log('Erreur', _error);

          var status = _error.status;
          if (status == 422) {
            $('.banner-stock-max--container').addClass('opened');
            setTimeout(function () {
              $('.banner-stock-max--container').removeClass('opened');
            }, 4000);
          }
        }
      });
    } else {
      if (type == 'product') {
        $this.children('.button--loading').css('display', 'none');

        if (window.matchMedia("(max-width: 767px)").matches) {
          $this.children('.button--text.hidden__desktop').css('display', 'block');
        } else {
          $this.children('.button--text.hidden__phone').css('display', 'block');
        }
        $('.select__custom--selected-value-container.select-product').addClass('effect-no-variant');
        $('.product-sticky-buybox__select.select__custom--selected-value-container').addClass('effect-no-variant');
        if (window.location.pathname.match(/^\/en/)) {
          $('.select__custom--selected-value-container.select-product #select__custom--1').text('Select a size');
        } else {
          $('.select__custom--selected-value-container.select-product #select__custom--1').text('Sélectionnez une taille');
        }

        setTimeout(function () {
          $('.select__custom--selected-value-container.select-product').removeClass('effect-no-variant');
          $('.product-sticky-buybox__select.select__custom--selected-value-container').removeClass('effect-no-variant');
          if (window.location.pathname.match(/^\/en/)) {
            $('.select__custom--selected-value-container.select-product #select__custom--1').text('Size available');
          } else {
            $('.select__custom--selected-value-container.select-product #select__custom--1').text('Tailles disponibles');
          }
        }, 3000);
      }
    }
  }
});

$('body').on('click', '.add__to__cart--grid-item', function (e) {
  e.preventDefault();
  var $this = $(this);
  var variant_id = $this.attr('product-variant');
  var productHandle = $(this).attr('data-product-handle');
  var productId = $(this).attr('data-product-id');
  var productType = $(this).attr('data-product-type');
  var productTitle = $(this).attr('data-product-title');
  var productPrice = $(this).attr('data-product-price');
  var qty = 1;
  var objUpdate = { quantity: qty, id: variant_id };
  $.ajax({
    type: "POST",
    url: '/cart/add.js',
    data: objUpdate,
    dataType: "json",
    success: function success(response) {
      updateCartData();
      document.dispatchEvent(new CustomEvent('update-reco-drawer'));
      if (window.dataLayer) {
        window.dataLayer.push({
          "event": "addToCart",
          "productName": productTitle || "",
          "productHandle": productHandle || "",
          "productType": productType || "",
          "productID": productId || "",
          "variantID": variant_id || "",
          "productPrice": response.price / 100,
          "quantity": 1
        });
      }

      setTimeout(function () {
        $this.children('.button--loading').css('display', 'none');
        $this.children('.button--text').show();
      }, 300);

      if (window.matchMedia("(max-width: 767px)").matches) {
        setTimeout(function () {
          $('#drawer__cart--exta-infos').removeClass('opened');
        }, 500);
      }
    },
    error: function error(_error2) {
      console.log('erreur');
      console.log(_error2);
    }
  });
});

$('body').on('change', '.qty--input', function (e) {
  e.preventDefault();
  var $this = $(this);
  var variantId = $(this).attr('variant-id');
  var variantQty = $this.val();

  if (variantId) {
    var data = { updates: {} };
    data.updates[variantId] = variantQty;

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function success(response) {
        // On render le cart via le module shippinh-module-cart.js
        updateCartData();
      },
      error: function error(_error3) {
        console.log('erreur');
      }
    });
  }
});

$('body').on('click', '.quantity__change--selector', function (e) {
  e.preventDefault();
  var $this = $(this);
  var variantId = $(this).attr('variant-id');
  var variantQty = $(this).attr('variant-qty');

  if (variantId) {
    var data = { updates: {} };
    data.updates[variantId] = variantQty;

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function success(response) {
        $('.quantity__current[variant-id="' + variantId + '"]').val(variantQty);
        $('.quantity__change--selector[type="minus"][variant-id="' + variantId + '"]').attr('variant-qty', parseInt(variantQty) - 1);
        $('.quantity__change--selector[type="plus"][variant-id="' + variantId + '"]').attr('variant-qty', parseInt(variantQty) + 1);
        updateCartData();

        if (window.cart && window.cart.drawer) {
          document.dispatchEvent(new CustomEvent('cart:open'));
        }
      },
      error: function error(_error4) {
        console.log('erreur');
      }
    });
  }
});

$('body').on('click', '.remove--line-item', function (e) {
  e.preventDefault();
  var $this = $(this);
  var key = $(this).attr('key');

  var data = { updates: {} };
  data.updates[key] = 0;
  setTimeout(function () {
    $('.cart__item--container[key="' + key + '"]').remove();
  }, 300);
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function success(response) {
      updateCartData();
      document.dispatchEvent(new CustomEvent('update-reco-drawer'));
    },
    error: function error(_error5) {
      console.log('erreur');
    }
  });
});

var renderCart = function renderCart() {

  var urlCart = '';
  if (window.location.pathname.match(/^\/en/)) {
    urlCart = '/en/cart?view=sidecart&timestamp=' + Date.now();
  } else {
    urlCart = '/cart?view=sidecart&timestamp=' + Date.now();
  }
  if (window.location.pathname == '/cart' > -1) {
    url = '/cart?view=page&timestamp=' + Date.now();
  }

  $.ajax({
    type: 'GET',
    url: urlCart,
    success: function success(content) {
      var newCart = content;
      $('.cart__items__and__header--container').remove();
      $('.cart--body').append(newCart);
    },
    error: function error(_error6) {
      console.log('erreur');
    }
  });
};

if (window.cart && window.cart.drawer == true) {
  renderCart();
}

var updateCartData = function updateCartData() {
  var urlCart = '';
  if (window.location.pathname.match(/^\/en/)) {
    urlCart = '/en/cart';
  } else {
    urlCart = '/cart';
  }
  $.ajax({
    type: 'GET',
    url: urlCart,
    dataType: 'json',
    success: function success(response) {
      var total = response.total_price;
      var empty = response.item_count == 0 ? true : false;
      updateDeliveryModule(total);
      renderCart();
      if (empty) {
        $('.cart--body').addClass('empty__cart');
        $('.cart__total--drawer, .vertical--separator').addClass('display__none');
        $('.empty__cart--drawer').removeClass('display__none');
        $('.items--count').text(0);
        $('.subtotal--container').addClass('display__none');

        if ($('#full__cart--title').length > 0) {
          location.reload(true);
        }
      } else {
        $('.cart--body').removeClass('empty__cart');
        $('.empty__cart--drawer').addClass('display__none');
        $('.cart__total--drawer, .vertical--separator').removeClass('display__none');
        $('.cart__total--drawer').text(displayPrice(total));
        $('.subtotal--container').removeClass('display__none');

        $('.items--count').text(response.item_count);

        $('.cart__item--total-price').text(displayPrice(total));
        response.items.forEach(function (line_item) {
          var variantId = line_item.variant_id;
          $('.cart__item--container[variant-id=' + variantId + '] .cart__item--total-price').text(displayPrice(line_item.line_price));
        });
      }
    },
    error: function error(_error7) {
      console.log('erreur');
    }
  });
};

$('#checkout--button').on('click', function (e) {
  if (window.dataLayer) {
    window.dataLayer.push({
      "event": "initiateCheckout",
      "stepNumber": "1"
    });
  }
  document.location.href = "/checkout";
});

// Gestion du theme editor
document.addEventListener('update-bar', function (e) {
  updateCartData();
}, false);

$('.text-under-cart').on('click', function () {
  $('#cart__drawer--header .close').click();
});
'use strict';

if (window.cart) {
  var deliveryModuleWidth = 100;
  var renderFirst = 0;

  var nbSteps = window.cart.nbSteps;
  if (nbSteps > 1 && nbSteps < 3) {
    deliveryModuleWidth = 33.33;
  } else if (nbSteps > 2) {
    deliveryModuleWidth = 25;
  }
  var ajaxCartProducts = function ajaxCartProducts(qty1, qty2) {
    /*var objUpdate = {updates: {}};
    objUpdate.updates[39372618596457] = qty1;
    objUpdate.updates[39372619382889] = qty2;
     $.ajax({
      type: "POST",
      url: '/cart/update.js',
      data: objUpdate,
      dataType: "json",
      success: function(response) {
        renderCart()
      },
      error: function(error) {
        console.log(error)
      }
    });*/
  };

  var shippingBarLogic = function shippingBarLogic(total) {
    var currentStep = 1;
    if (total >= window.cart.steps[0] && total < window.cart.steps[1]) {
      currentStep = 2;
    } else if (total >= window.cart.steps[1]) {
      currentStep = 3;
    }

    var remainMoney = 0;
    var remainPercentage = 0;
    var colorBar = 0;

    var barCalculus = function barCalculus(step, total) {
      var seuilSuivant = window.cart.steps[step - 1];
      var seuilPrecedent = 0;
      if (step != 1) {
        seuilPrecedent = window.cart.steps[step - 2];
      }

      remainMoney = Math.max(0, (seuilSuivant - total) / 100);
      remainPercentage = Math.max(0, (seuilSuivant - total) / (seuilSuivant - seuilPrecedent));
      colorBar = deliveryModuleWidth * step - deliveryModuleWidth * remainPercentage;
    };

    var finalStep = function finalStep() {
      remainMoney = 0;
      remainPercentage = 0;
      colorBar = 100;
    };

    switch (currentStep) {
      case 1:
        barCalculus(1, total);
        break;
      case 2:
        barCalculus(2, total);
        break;
      case 3:
        barCalculus(3, total);
        break;
      default:
        break;
    }

    if (currentStep == 1) {
      ajaxCartProducts(0, 0);
    } else if (currentStep == 2 && nbSteps > 1) {
      if (nbSteps == 1) {
        finalStep();
      } else {
        if (window.cart.deliveryStep == 1) {
          ajaxCartProducts(0, 0);
        } else {
          ajaxCartProducts(1, 0);
        }
      }
    } else {
      finalStep();
      if (window.cart.deliveryStep == 0 && nbSteps == 2) {
        ajaxCartProducts(1, 1);
      } else if (window.cart.deliveryStep == 0 && nbSteps == 1) {
        ajaxCartProducts(1, 0);
      } else if ((window.cart.deliveryStep == 1 || window.cart.deliveryStep == 2) && nbSteps == 2) {
        ajaxCartProducts(1, 0);
      } else {
        ajaxCartProducts(0, 0);
      }
    }

    $('#progress__bar--remain').css('width', colorBar + '%');

    if (remainMoney > 0) {
      var moinsDix = remainMoney < 10 ? true : false;
      remainMoney = remainMoney.toString().replace('.', ',');
      if (moinsDix == true && remainMoney.length == 3) {
        remainMoney = remainMoney + '0';
      } else if (moinsDix == false && remainMoney.length == 4) {
        remainMoney = remainMoney + '0';
      }

      $('#free__shipping--message').hide();
      $('#remain__shipping__amount--message').show();
      $('#amount__remaining').text(remainMoney + "€");
    } else {
      $('#free__shipping--message').show();
      $('#remain__shipping__amount--message').hide();
    }
  };

  var getCartTotal = function getCartTotal(callback, cart) {
    if (cart) {
      if (callback) {
        callback(cart.total_price);
      } else {
        return cart.total_price;
      }
    } else {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function success(cart) {
          if (callback) {
            callback(cart.total_price);
          } else {
            return cart.total_price;
          }
        }
      });
    }
  };

  var initializeDeliveryModule = function initializeDeliveryModule() {
    var total = getCartTotal(shippingBarLogic);
  };

  setTimeout(function () {
    initializeDeliveryModule();
  }, 1000);

  var updateDeliveryModule = function updateDeliveryModule(total) {
    if (window.cart.deliveryModule) {
      if (total) {
        shippingBarLogic(total);
      } else {
        getCartTotal(shippingBarLogic);
      }
    }
  };
}
"use strict";

var emballageCadeauVariantId = window.giftBoxvariant;
$(".emballage__cadeau--button").on("click", function () {
  var data = { updates: {} };
  data.updates[emballageCadeauVariantId] = 1;
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function success() {
      location.reload();
    }
  });
});
'use strict';

document.addEventListener('update-reco-drawer', function (e) {
  $.ajax({
    type: 'GET',
    url: 'https://' + window.location.hostname + '/?section_id=reco-lateral',
    success: function success(data) {
      $('#product-reco--container').empty().append(data);
    },
    error: function error(_error) {
      console.log('erreur');
      console.log(_error);
    }
  });
}, false);

$('body').on('click', '.reco--aded-to-cart', function (e) {
  var handle = $(this).attr('product-handle');
  if (typeof ga === "function") {
    ga('send', 'event', 'Produit recommandé', 'Ajout au panier', handle);
  }
});

// document.dispatchEvent(new CustomEvent('update-reco-drawer')); --> a ajouter lors des ajouts au panier
'use strict';

if (window.collection) {
  var selectedInput = $('.select__custom--value[value="' + window.collection.defaultSortBy + '"]').first().text();

  $('.select__custom--value[value="' + window.collection.defaultSortBy + '"]').addClass('is__active');

  console.log(window.collection.defaultSortBy);

  if (window.collection.defaultSortBy == "best-selling" || window.collection.defaultSortBy == "created-descending" || window.collection.defaultSortBy == "price-ascending" || window.collection.defaultSortBy == "price-descending") {
    $('.trierCount').show();
  }

  /*if (window.matchMedia("(min-width: 768px)").matches) {
    $('.select__custom--selected-value').text(selectedInput)
  }*/

  $('.see-more-collection').on('click', function () {
    if ($('.breadcrumb-title--container .description').hasClass('see-more')) {
      $('.breadcrumb-title--container .description').removeClass('see-more');
      $(this).text(window.general.see_less);
    } else {
      $('.breadcrumb-title--container .description').addClass('see-more');
      $(this).text(window.general.see_more);
    }
  });
}

if (window.location.href.indexOf('/collections/') > -1) {
  var lastScrollTop = 0;

  $(window).scroll(function () {
    var scrollTop = $(this).scrollTop();

    if (scrollTop > 200) {
      if (scrollTop > lastScrollTop) {
        // Scroll down
        $('#shopify-section-navigation--logo-center').addClass('hide');
        $('.filter-collection--container').removeClass('slide-from-top');
      } else {
        // Scroll up
        $('#shopify-section-navigation--logo-center').removeClass('hide');
        $('.filter-collection--container').addClass('slide-from-top');
      }
    } else {
      // Si le défilement est au-dessus de 200 pixels, retirer la classe 'hide'
      $('#shopify-section-navigation--logo-center').removeClass('hide');
      $('.filter-collection--container').addClass('slide-from-top');
    }

    lastScrollTop = scrollTop;
  });
}
'use strict';

if (window.location.href.indexOf("/collection") > -1) {
  var printUrl = function printUrl(list) {
    var filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + "?";
    for (var filter in list) {
      filteredUrl += list[filter].type + "=" + list[filter].value + "&";
    }

    var sortBy = $('#sort__by--container .select__custom--value.is__active').attr('value');
    var filterSortBy = 'sort_by=' + sortBy;

    var pageUrl = '';
    /*if (window.location.href.indexOf('page=') > -1){
      var url_string = window.location.href
      var url = new URL(url_string);
      var numberPage = url.searchParams.get("page");
      pageUrl = "&page=" + numberPage
     }*/

    var finalUrl = filteredUrl + filterSortBy + pageUrl;

    if (history.replaceState) {
      window.history.replaceState({ path: finalUrl }, '', finalUrl);
    }

    $.ajax({
      type: 'GET',
      url: finalUrl + '&view=filtered',
      success: function success(content) {
        //var count = parseInt(content.substring(0, 5));

        var parser = new DOMParser();
        var doc = parser.parseFromString(content, 'text/html');
        var countElement = doc.querySelector('.count-product');
        var count = countElement.textContent;
        $('.filter-count').text(count);
        $('#collection__list--container').remove();
        $('#collection__page--desktop').append(content);

        clearFilter();

        var countfilter = 0;
        $('.filter--container').each(function () {
          if ($(this).hasClass('checked')) {
            countfilter = countfilter + 1;
          }
        });

        var valueLow = $('#lowPriceFilter').val();
        var valueHigh = $('#highPriceFilter').val();
        var maxValueHigh = $('#highPriceFilter').attr('max');

        if (parseInt(valueLow) > 0) {
          countfilter += 1;
        } else if (parseInt(valueHigh) < parseInt(maxValueHigh)) {
          countfilter += 1;
        }

        if (countfilter == 0) {
          $('.filterCount').hide().text('');
        } else {
          $('.filterCount').show().text('(' + countfilter + ')');
        }
      },
      error: function error(_error2) {
        console.log('erreur');
      }
    });
  };

  var printActive = function printActive() {
    var countActive = 0;
    $('.active-filters').html('');
    $(".filter-group-display__list-item").each(function () {
      var checkbox = $(this).find('.checkbox-filter--container');
      if (checkbox.hasClass('checked') && checkbox.attr('name') != 'filter.v.availability') {
        countActive += 1;
        var name = $(this).find('.checkbox-filter--container').attr('filtername');
        var value = $(this).find('.checkbox-filter--container').attr('value');

        $('.active-filters').removeClass('hidden').append('\n          <a class="active-filters__remove-filter flex fd--row cursor--pointer text__uppercase ' + (countActive > 6 ? 'active-filters__more-than-six' : '') + '" filtername="' + name + '">\n              <p class="text--nav mh--5 margin__left--none">' + value + '</p>\n              <svg width="16px" height="16px" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#898989"><path d="M6.75827 17.2426L12.0009 12M17.2435 6.75736L12.0009 12M12.0009 12L6.75827 6.75736M12.0009 12L17.2435 17.2426" stroke="#898989" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>\n          </a>\n        ');
      }
    });

    if (countActive > 6) {
      $('.active-filters').append('\n            <div class="view-more-filters flex flex--row text--nav text__uppercase cursor--pointer"><span class="text-see-more-less mh--5 margin__left--none">Voir plus</span> <svg width="16px" height="16px" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#898989"><path d="M6 9L12 15L18 9" stroke="#898989" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>\n          ');
    }

    if (countActive > 1) {
      $('.remove-filters--container').html('');
      $('.remove-filters--container').append('\n        <p class="delete-all-filters text--nav text__uppercase mh--15 margin__left--none ' + countActive + '">Tout effacer</p>\n      ');
    } else {
      $('.remove-filters--container').html('');
    }
    if (countActive === 0) {
      $('.active-filters').addClass('hidden');
    }
  };

  // Filters
  $('body').on('click', '.reinitialize__filters', function () {
    window.collection.currentFilters = [];
    $('.reinitialize__filters').hide();
    $('.filter__item--mini').remove();
    $('.filter__button').removeClass('is__active');
    var filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + '?sort_by=' + window.collection.sortBy;
    if (history.replaceState) {
      window.history.replaceState({ path: filteredUrl }, '', filteredUrl);
    }
    $.ajax({
      type: 'GET',
      url: filteredUrl + '&view=filtered',
      success: function success(content) {
        var count = parseInt(content.substring(0, 4));
        $('.filter-count').text(count);
        $('#collection__list--container').remove();
        $('#collection__page--desktop').append(content.substring(4));
      },
      error: function error(_error) {
        console.log('erreur');
      }
    });
  });

  $('body').on('click', '.filter__item--mini', function () {
    var filter_value = $(this).attr('filter-value-handle');
    $('.filter__item--mini[filter-value-handle=' + filter_value + ']').remove();
    $('.filter__button[filter-value-handle=' + filter_value + ']')[0].click();
  });

  var collectionFilter = {};
  if ($('[collection-filter]').html()) {
    collectionFilter = JSON.parse($('[collection-filter]').html());
  }

  //Range slider price
  var $range = $(".js-range-slider"),
      $from = $(".from"),
      $to = $(".to"),
      range,
      min = $range.data('min'),
      max = $range.data('max'),
      from,
      to;

  var updateValues = function updateValues() {
    $from.prop("value", from);
    $to.prop("value", to);

    dataFilter = boucleFilter();
    console.log(dataFilter);
    printUrl(dataFilter);
  };

  var updateFilter = function updateFilter() {
    var maxRange = collectionFilter.filterMaxRange / 100;
    if (from == '0' && to == maxRange) {
      $('.active-filters__remove-filter[filtername="filter-price"]').hide();
    } else {
      $('.active-filters__remove-filter[filtername="filter-price"]').show();
      $('.min-value-filter').text(from + "€");
      $('.max-value-filter').text(to + "€");
    }
  };

  $range.ionRangeSlider({
    onChange: function onChange(data) {
      from = data.from;
      to = data.to;
      updateValues();
      updateFilter();
      $('.irs-from, .irs-to').append(' €');
    }
  });

  $(window).bind("load", function () {
    $('.irs-from, .irs-to').append(' €');
  });

  range = $range.data("ionRangeSlider");
  var updateRange = function updateRange() {
    range.update({
      from: from,
      to: to
    });
  };

  $from.on("input", function () {
    from = +$(this).prop("value");
    if (from < min) {
      from = min;
    }
    if (from > to) {
      from = to;
    }
    updateValues();
    updateRange();
    updateFilter();
  });

  $to.on("input", function () {
    to = +$(this).prop("value");
    if (to > max) {
      to = max;
    }
    if (to < from) {
      to = from;
    }
    updateValues();
    updateRange();
    updateFilter();
  });

  $(document).ready(function () {
    if (collectionFilter.filterMaxValue != '') {
      to = collectionFilter.filterMaxValue / 100;
    }
    if (collectionFilter.filterMinValue != '') {
      from = collectionFilter.filterMinValue / 100;
    }
    //updateValues();
    updateRange();
  });

  var clearFilter = function clearFilter() {
    var url = window.location.href;
    var matches = url.match(/[a-z\d]+=[a-z\d]+/gi);
    var count = matches ? matches.length : 0;
    if (window.location.search.indexOf('page=') > -1) {
      count = count - 1;
    }
    /*if(count > 1 ){
      $('.active-filters__clear').show()
    } else {
      $('.active-filters__clear').hide()
    }*/
  };

  $(document).ready(function () {
    clearFilter();
    printActive();
    var countfilter = 0;
    $('.filter--container').each(function () {
      if ($(this).hasClass('checked')) {
        countfilter = countfilter + 1;
      }
    });

    var valueLow = $('#lowPriceFilter').val();
    var valueHigh = $('#highPriceFilter').val();
    var maxValueHigh = $('#highPriceFilter').attr('max');

    if (parseInt(valueLow) > 0) {
      countfilter += 1;
    } else if (parseInt(valueHigh) < parseInt(maxValueHigh)) {
      countfilter += 1;
    }

    if (countfilter == 0) {
      $('.filterCount').hide().text('');
    } else {
      $('.filterCount').show().text('(' + countfilter + ')');
    }
  });

  var dataFilter = [];

  var boucleFilter = function boucleFilter() {
    var array = [];
    $(".filter-group-display__list").each(function () {
      var containerFilter = $(this).children('.filter-group-display__list-item');

      var checkbox = containerFilter.children('.filter--container').children('.checkbox-filter--container');
      var value = "";
      var name = checkbox.attr('name');
      var compteurCheck = 0;
      var count = 0;
      for (var i = 1; i <= containerFilter.length; i++) {
        var loopCheckbox = containerFilter.children('.filter--container').children('.checkbox-' + i);

        if (loopCheckbox.hasClass('checked')) {

          if ((name == "filter.v.option.taille" || name == "filter.v.option.size") && count < 1) {
            array.push({ type: "filter.v.availability", value: 1 });
            count = 1;
          }
          console.log(count);

          compteurCheck += 1;

          compteurCheck == 1 ? value = loopCheckbox.attr('value') : value = value + ',' + loopCheckbox.attr('value');
        }
      }
      compteurCheck > 0 ? array.push({ type: name, value: value }) : null;
    });

    var nameFilterLow = $('#lowPriceFilter').attr('name');
    var valueLow = $('#lowPriceFilter').val();

    var nameFilterHigh = $('#highPriceFilter').attr('name');
    var valueHigh = $('#highPriceFilter').val();
    var maxValueHigh = $('#highPriceFilter').attr('max');

    console.log(valueLow);
    console.log(valueHigh);
    console.log(maxValueHigh);
    if (parseInt(valueLow) > 0) {
      array.push({ type: nameFilterLow, value: valueLow });
    }

    if (parseInt(valueHigh) < parseInt(maxValueHigh)) {
      array.push({ type: nameFilterHigh, value: valueHigh });
    }

    return array;
  };

  if (window.location.href.indexOf("collections") > -1) {

    dataFilter = boucleFilter();

    console.log('Chargement');
    console.log(dataFilter);
    console.log('Chargement');
  }

  $('body').on('click', '.filter--container', function () {
    var filterTaille = $(this).find('.checkbox-filter--container').attr('name');
    var nameCategorie = filterTaille.split('filter.p.m.my_fields.');
    gtag('event', 'filter', {
      'label': nameCategorie[1]
    });
    if ($(this).find('.checkbox-filter--container').hasClass('checked')) {
      var filterName = $(this).find('.checkbox-filter--container').attr('filtername');
      $('.active-filters__remove-filter[filtername=' + filterName + ']').remove();
    } else {
      var filterName = $(this).find('.checkbox-filter--container').attr('filtername');

      if (filterName == 'Disponibilité-Enstock') {
        var filterValue = 'En stock';
      } else if (filterTaille == 'filter.v.option.taille' || filterTaille == "filter.v.option.size") {
        console.log('Taille click');
        /*$('.taille--container').removeClass('checked')
        $('.taille--container').children('.checkbox-filter--container').removeClass('checked')*/
      } else {
        var filterValue = $(this).find('.checkbox-filter--container').attr('value');
      }
    }

    var checkboxContainer = $(this).children('.checkbox-filter--container');
    checkboxContainer.hasClass('checked') ? checkboxContainer.removeClass('checked') : checkboxContainer.addClass('checked');
    $(this).hasClass('checked') ? $(this).removeClass('checked') : $(this).addClass('checked');

    dataFilter = boucleFilter();

    console.log(dataFilter);
    printUrl(dataFilter);
    printActive();
  });

  $('body').on('click', '.active-filters__remove-filter', function () {
    var filter_value = $(this).attr('filtername');
    $('.filter--container[filter-handle="' + filter_value + '"]').click();
  });

  if (window.matchMedia("(max-width: 767px)").matches) {
    $('body').on('click', '.filter-group-summary', function () {
      if ($(this).hasClass('checked')) {
        $(this).removeClass('checked');
        $(this).siblings('.filter-group-display').slideToggle(200);
        $(this).children('.icon--arrow-bottom').removeClass('opened');
      } else {
        $(this).addClass('checked');
        $(this).siblings('.filter-group-display').slideToggle(200);
        $(this).children('.icon--arrow-bottom').addClass('opened');
      }
    });
  }

  $('body').on('click', '.reini-button-filter', function () {
    console.log('passe ici reini');
    var link = $(this).children('.active-filters__clear').attr('link');
    $('.filter--container, .checkbox-filter--container').removeClass('checked');
    $('#lowPriceFilter').attr('value', 0);
    var maxRangeValue = collectionFilter.filterMaxRange / 100;

    $('#highPriceFilter').attr('value', maxRangeValue);
    $('#highPriceFilter').val(maxRangeValue);
    to = maxRangeValue;
    from = 0;
    updateValues();
    updateRange();
    $('.irs-from, .irs-to').append(' €');
    window.history.replaceState({ path: link }, '', link);

    $('.count-filter--container').addClass('hide');

    $.ajax({
      type: 'GET',
      url: link + '&view=filtered',
      success: function success(content) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(content, 'text/html');
        var countElement = doc.querySelector('.count-product');
        var count = countElement.textContent;
        $('.filter-count').text(count);
        $('#collection__list--container, .collection-remove--container').remove();
        $('#collection__page--desktop').append(content);

        clearFilter();
        printActive();
        $('.filterCount').hide().text('');
      },
      error: function error(_error3) {
        console.log('erreur');
      }
    });
  });

  $('body').on('click', '.filter__button', function () {
    var mini__filter = window.collection.miniFilter;
    var filter_value = $(this).attr('filter-value-handle'),
        filteredUrl = '';
    var filtersList = window.collection.currentFilters;

    if ($(this).hasClass('is__active')) {
      $('.filter__button[filter-value-handle=' + filter_value + ']').removeClass('is__active');

      filtersList.splice(filtersList.indexOf(filter_value), 1);

      window.collection.currentFilters = filtersList;
      window.collection.currentFilters.sort();

      $('.filter__item--mini[filter-value-handle=' + filter_value + ']').remove();
    } else {
      // Supprime les tags du meme groupe deja actifs
      var group = filter_value.split('_')[0];
      $('.filter__button[filter-group-handle="' + group + '"]').removeClass('is__active');
      $('.filter__item--mini[filter-group-handle="' + group + '"]').remove();
      $('.filter__button[filter-value-handle=' + filter_value + ']').addClass('is__active');
      for (var i = 0; i < filtersList.length; i++) {
        if (filtersList[i].indexOf(group) > -1) {
          filtersList.splice(i, 1);
        }
      }

      window.collection.currentFilters = filtersList;
      window.collection.currentFilters.push(filter_value);
      window.collection.currentFilters.sort();

      $('.filter__values--list').append('<li class="filter__item--mini body--text--footer" filter-value-handle="' + filter_value + '" filter-group-handle="' + group + '"><span>' + $(this).attr('filter-group') + ': ' + $(this).attr('filter-value') + '</span><span class="close close__filter"></span></li>');
    }

    if (window.collection.currentFilters.length > 0) {
      $('.reinitialize__filters').show();
      filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + '/' + window.collection.currentFilters.join('+') + '?sort_by=' + window.collection.sortBy;
    } else {
      $('.reinitialize__filters').hide();
      filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + '?sort_by=' + window.collection.sortBy;
    }

    if (history.replaceState) {
      window.history.replaceState({ path: filteredUrl }, '', filteredUrl);
    }

    $.ajax({
      type: 'GET',
      url: filteredUrl + '&view=filtered',
      success: function success(content) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(content, 'text/html');
        var countElement = doc.querySelector('.count-product');
        var count = countElement.textContent;
        $('.filter-count').text(count);
        $('#collection__list--container').remove();
        $('#collection__page--desktop').append(content);
      },
      error: function error(_error4) {
        console.log('erreur');
      }
    });
  });

  // mobile
  $('.action--button-validate').on('click', function (e) {
    e.preventDefault();
    $('#navigation__drawer--header .close').click();
  });
  $('.action--button-close').on('click', function (e) {
    e.preventDefault();
    $('#navigation__drawer--header .close').click();
  });

  $('.filter__group--title').on('click', function () {
    $(this).children('plus__icon').toggleClass('opened');
    $(this).siblings('.filter__group--item-list').slideToggle(300);
    $(this).toggleClass('opened');
  });

  $('body').on('click', '.see-more', function () {
    var which = $(this).attr('which');
    $('.see-more[which="' + which + '"]').hide();
    $('.see-less[which="' + which + '"]').show();

    $('.filter-group-display.' + which + '--container').addClass('opened');
  });

  $('body').on('click', '.see-less', function () {
    var which = $(this).attr('which');
    $('.see-more[which="' + which + '"]').show();
    $('.see-less[which="' + which + '"]').hide();

    $('.filter-group-display.' + which + '--container').removeClass('opened');
  });

  /*if (window.matchMedia("(max-width: 767px)" ).matches) {
    $('.desktop-filter').remove()
  } else {
    $('.mobile-filter').remove()
  }*/
}

/* Nouveau dev */
$('body').on('click', '.delete-all-filters', function (e) {
  $('.reini-button-filter').click();
});

$('body').on('click', '.view-more-filters', function () {
  console.log('passe click view more');
  console.log(this);
  if ($(this).hasClass('active')) {
    console.log('passe 1');
    $(this).removeClass('active');
    $(this).find('.text-see-more-less').html('Voir plus');

    $('.active-filters__more-than-six').removeClass('active');
  } else {
    console.log('passe 2');
    $(this).addClass('active');
    $(this).find('.text-see-more-less').html('Voir moins');

    $('.active-filters__more-than-six').addClass('active');
  }
});
'use strict';

$('.product__item__link--container .one-color, .product__item__link--container .color').on('click', function (e) {
  e.preventDefault();
  if ($(e.target).is('.one-color') || $(e.target).is('.color')) {
    console.log('passe color target');
    console.log(e.target);
    var link = $(e.target).attr('link');
    var productId = $(e.target).attr('product-id');
    var url = window.location.host + link + '.js';
    console.log(url);
    jQuery.getJSON(url, function (product) {
      var featured = product.featured_image;
      var secondImage = product.images[1];
      var thirdImage = product.images[2];
      $('.image-1[product-id=' + productId + ']').attr('src', featured);
      $('.image-2[product-id=' + productId + ']').attr('src', secondImage);
      $('.image-3[product-id=' + productId + ']').attr('src', thirdImage);
    });
  }
});

$(document).ready(function () {
  $('.w3-carousel-css').each(function () {
    var $carousel = $(this); // ✅ On garde la référence au carrousel courant
    var $leftArrow = $carousel.find('.carousel-arrow-left');
    var $rightArrow = $carousel.find('.carousel-arrow-right');
    var $container = $carousel.find('.product-card__slider--css');
    var $slides = $container.find('.product-card__slider--image');
    var $paginationDots = $carousel.find('.product-card__slider--pagination-dots');

    function scrollContainer($element) {
      var scrollAmount = $carousel.outerWidth(); // ✅ Utilise bien le carrousel

      if ($element.hasClass('carousel-arrow-left')) {
        $container.animate({ scrollLeft: $container.scrollLeft() - scrollAmount }, 300, checkArrowsAndPagination);
      } else {
        $container.animate({ scrollLeft: $container.scrollLeft() + scrollAmount }, 300, checkArrowsAndPagination);
      }
    }

    function checkArrowsAndPagination() {
      var scrollLeft = $container.scrollLeft();
      var maxScrollLeft = $container[0].scrollWidth - $container.outerWidth();

      // Gestion des flèches
      if (scrollLeft <= 0) {
        $leftArrow.find('.carousel-arrow--wrapper').addClass('hidden');
      } else {
        $leftArrow.find('.carousel-arrow--wrapper').removeClass('hidden');
      }

      if (scrollLeft >= maxScrollLeft - 1) {
        $rightArrow.find('.carousel-arrow--wrapper').addClass('hidden');
      } else {
        $rightArrow.find('.carousel-arrow--wrapper').removeClass('hidden');
      }

      // Gestion de la pagination
      var sliderRect = $container[0].getBoundingClientRect();
      var centerX = sliderRect.left + sliderRect.width / 2;

      var closestIndex = 0;
      var closestDistance = Infinity;

      $slides.each(function (i) {
        var slideRect = this.getBoundingClientRect();
        var slideCenter = slideRect.left + slideRect.width / 2;
        var distance = Math.abs(centerX - slideCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });

      $paginationDots.each(function (i) {
        $(this).toggleClass('active', i === closestIndex);
      });
    }

    // Click events
    $carousel.find('.carousel-arrow').on('click', function () {
      console.log('click arrow');
      scrollContainer($(this));
    });

    // Scroll event
    $container.on('scroll', function () {
      checkArrowsAndPagination();
    });

    // Init state
    checkArrowsAndPagination();
  });
});
'use strict';

// Ouvrir la modal au clic
$('body').on('click', '.button__action', function (e) {
  e.preventDefault();
  var buttonFor = $(this).attr('for');
  var selector = $(this).attr('open-selector');
  if (selector) {
    $(selector).addClass('opened');
    if (selector == '#filter-collection-drawer') {
      $('#page__overlay--filter').addClass('opened');
    } else {
      $('#page__overlay').addClass('opened');
    }
  }

  if (buttonFor == 'modal' && selector) {
    $('#page__overlay').attr('for', 'modal');
  } else if (buttonFor == 'drawer' && selector) {
    $('#page__overlay').attr('for', 'drawer');
    if (window.matchMedia("(max-width: 768px)").matches) {
      $('html, body').css({ overflow: 'hidden' });
    }
  } else if (buttonFor == 'drawer-filter' && selector) {
    /*if (window.matchMedia("(min-width: 768px)").matches) {
      $(selector).slideToggle(200).addClass('opened-desktop')
      $('html, body').css({overflow: 'hidden'});
      $('html, body').animate({
        scrollTop: 0
      }, 500);
       $(this).addClass('opened close').removeClass('button__action')
    }*/
  } else if (buttonFor == 'drawer-cart' && selector) {
    $('#page__overlay').attr('for', 'drawer');
    if (window.matchMedia("(max-width: 768px)").matches) {
      $('html, body').css({ overflow: 'hidden' });
    }
    setTimeout(function () {
      $('#drawer__cart--exta-infos').addClass('opened');
    }, 350);
  } else if (buttonFor == 'accordeon') {
    var isActive = false;
    if ($(this).hasClass('active')) {
      isActive = true;
    }
    if ($(this).hasClass('link--item-button')) {
      $('.link--item-button.active').siblings('.accordeon__list').removeClass('opened').slideToggle('500');
      $('.link--item-button.active').children('.plus__icon').removeClass('opened');
      $('.link--item-button.active').removeClass('active');
    } else if ($(this).hasClass('sub__link--item-button')) {
      $('.sub__link--item-button.active').siblings('.accordeon__list').removeClass('opened').slideToggle('500');
      $('.sub__link--item-button.active').children('.plus__icon').removeClass('opened');
      $('.sub__link--item-button.active').removeClass('active');
    }

    if (isActive == false) {
      $(this).toggleClass('active');
      $(this).children('.plus__icon').toggleClass('opened');
      $(this).siblings('.accordeon__list').addClass('opened').slideToggle('500');
    }
  }
  if (buttonFor == 'select' && selector) {
    $('#page__overlay').attr('for', 'select');
  }
});

// Fermer la modal au clic sur la croix
$('body').on('click', '.close', function (e) {
  e.preventDefault();
  var closeFor = $(this).attr('for');

  $('#page__overlay').removeClass('opened');
  $('#page__overlay').attr('for', '');

  if (closeFor == 'modal') {
    $('.modal').removeClass('opened');
    $('.modal-loader').show();
    $('.modal-has-to-load').hide();
  } else if (closeFor == 'drawer-filter') {

    $('#filter-collection-drawer').removeClass('opened');

    $('html, body').css({ overflow: 'initial' });

    $('#page__overlay--filter').removeClass('opened');

    $(".filter").removeClass('opened close').addClass('button__action');
  } else if (closeFor == 'drawer') {
    $('.drawer').removeClass('opened');
    if (window.matchMedia("(max-width: 768px)").matches) {
      $('html, body').css({ overflow: 'visible' });
    }
  } else if (closeFor == 'select') {
    $('.select').removeClass('opened');
  }
});

$('#page__overlay--filter').on('click', function (e) {
  e.preventDefault();

  $('#page__overlay--filter').removeClass('opened');
  $('#filter-collection-drawer').removeClass('opened');
  $('html, body').css({ overflow: 'initial' });

  $(".filter").removeClass('opened close').addClass('button__action');
});

// Clic en dehors de la'modal'
$('#page__overlay').on('click', function (e) {
  e.preventDefault();
  var overlayFor = $(this).attr('for');

  if ($('#navigation__drawer').hasClass('opened')) {
    $('#navigation__drawer').removeClass('opened');
  }

  $(this).removeClass('opened');
  $('#page__overlay').attr('for', '');

  if (overlayFor == 'modal') {
    $('.modal').removeClass('opened');
    $('.modal-loader').show();
    $('.modal-has-to-load').hide();
  } else if (overlayFor == 'drawer') {
    $('.drawer').removeClass('opened');
    if (window.matchMedia("(max-width: 768px)").matches) {
      $('html, body').css({ overflow: 'visible' });
    }
  } else if (overlayFor == 'select') {
    $('.select').removeClass('opened');
  }
});

// Ajout de la variant lors de la selection + Fermer modal
$('.variant__select').on('click', function (e) {
  //$('#iddeclasse').attr('variant', $(this).attr("value"));
  e.preventDefault();
  $('.select').removeClass('opened');
  var closeFor = $(this).attr('for');
  $('#page__overlay').removeClass('opened');
  $('#page__overlay').attr('for', '');
});

$('#page__overlay--white').on('click', function (e) {
  e.preventDefault();
  $(this).removeClass('opened');
  $('.select__custom--values').hide();
  $('.select__custom--values').removeClass('opened');
});
"use strict";

if (window.location.href.indexOf("map") > -1) {
  var setMapAndList2 = function setMapAndList2(agencies) {

    var icon = {
      path: "M23.5,0C11.3,0,0.2,9.9,0.2,22.2C0.2,34.4,10.3,49,23.5,70c13.2-21,23.3-35.6,23.3-47.8C46.8,9.9,35.7,0,23.5,0z M23.5,32.1c-4.8,0-8.7-3.9-8.7-8.8c0-4.8,3.9-8.8,8.7-8.8c4.8,0,8.7,3.9,8.7,8.8C32.2,28.2,28.3,32.1,23.5,32.1z",
      fillColor: '#000000',
      fillOpacity: 1,
      anchor: new google.maps.Point(28, 70),
      strokeWeight: 0,
      scale: 0.8
    };

    //reset markers
    window.markers = [];
    window.markerclusterer = new MarkerClusterer(window.mapAgencies, window.markers, {
      imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      clusterClass: 'custom-clustericon',
      ignoreHidden: true
    });
    //window.markerclusterer.setIgnoreHidden(true);
    $('.sl-results-wrapper ul').html('');

    $.each(agencies, function (index, agence) {

      var agence = agence;
      var title = agence.title;
      var address = agence.address;
      var tel = agence.tel;
      var link = agence.link;
      var lat = agence.lat;
      var lng = agence.lng;

      var $html = $($('#template-agencies-list').html());
      $html.find('.cs-title').html(title);
      $html.find('.cs-address').html(address);
      $html.find('.cs-tel a').html(tel).attr('href', 'tel:' + tel);
      $html.find('.cs-link a').attr('href', link);

      textContents2.push($html.text().toLowerCase());

      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(lat, lng),
        icon: icon,
        map: window.mapAgencies
      });

      window.markers.push(marker);

      bounds2.extend(marker.position);

      google.maps.event.addListener(marker, 'click', function (marker, index) {
        return function () {
          infowindow2.setContent($html.html());
          infowindow2.open(window.mapAgencies, marker);
        };
      }(marker, index));

      google.maps.event.addListener(marker, 'visible_changed', function () {
        //console.log('marker '+index+' change detat :', marker.getVisible());
        if (marker.getVisible()) {
          window.markerclusterer.addMarker(marker, false);
          window.markerclusterer.repaint();
        } else {
          window.markerclusterer.removeMarker(marker, false);
          window.markerclusterer.repaint();
        }
      });

      //
      $('.sl-results-wrapper ul').append($html);
      window.markerclusterer.addMarkers(window.markers, true);
    });

    //console.log(textContents);

    window.mapAgencies.fitBounds(bounds2);

    var oldCenter = window.mapAgencies.getCenter();
  };

  var initMap = function initMap() {
    window.mapAgencies = new google.maps.Map(document.getElementById('sl-map'), {
      center: new google.maps.LatLng(48.871982, 2.291425),
      zoom: 12,
      maxZoom: 18,
      disableDefaultUI: false
    });

    var infowindow = new google.maps.InfoWindow();

    var bounds = new google.maps.LatLngBounds();

    var oldCenter;

    // Center change
    google.maps.event.addListener(window.mapAgencies, 'dragend', function () {
      oldCenter = window.mapAgencies.getCenter();
    });

    //Center map
    google.maps.event.addDomListener(window, 'resize', function () {
      window.mapAgencies.setCenter(oldCenter);
      oldCenter = window.mapAgencies.getCenter();
    });

    $(document).ready(function () {});
    $(function () {
      // Document ready
      /*var jsonDatas = [
        {
          "title": "Agence Nord Ouest",
          "address": "83 Boulevard Poissonnière 75002 Paris",
          "lat": "48.870476",
          "lng": "2.347683",
          "tel": "+33 (0)1 81 84 56 32",
          "link": "#"
        },
        {
          "title": "Agence Nord Est",
          "address": "Boulevard Carry 750020 Paris",
          "lat": "48.864576",
          "lng": "2.403977",
          "tel": "+33 (0)1 81 84 56 34",
          "link": "#"
        },
        {
          "title": "Agence Bordeaux",
          "address": "9 Allée James Watt 33300 Mérignac",
          "lat": "44.796676",
          "lng": "-0.603427",
          "tel": "+33 (0)1 81 84 56 31",
          "link": "#"
        },
        {
          "title": "Agence Montpellier",
          "address": "48 Rue Claude Balbastre, 34070 Montpellier",
          "lat": "43.611569",
          "lng": "3.915282",
          "tel": "+33 (0)1 81 84 56 30",
          "link": "#"
        }
      ];*/

      setMapAndList(jsonDatas);

      $('.sl-search input').on('keyup', filterResults);

      $('.sl-map-wrapper').on('mouseover', function () {
        $('input:focus').blur();
      });
    });

    var textContents = [];
    var matchesContents = [];

    function filterResults(e) {
      console.log('passe');
      var $obj = $(e.currentTarget);
      var searchString = $obj.val().toLowerCase();

      matchesContents = [];

      $.each(textContents, function (index, content) {
        if (searchString == '') {
          // IF input search not empty
          matchesContents.push(1);
        } else {
          // IF input search not empty
          if (content.indexOf(searchString) !== -1) {
            matchesContents.push(1);
          } else {
            matchesContents.push(0);
          }
        }
      });

      //console.log(matchesContents);

      $.each(window.markers, function (index, marker) {
        if (matchesContents[index] == 0) {
          marker.setVisible(false);
          $('.sl-results-wrapper ul li').eq(index).addClass('hidden');
        } else {
          marker.setVisible(true);
          $('.sl-results-wrapper ul li').eq(index).removeClass('hidden');
        }
        //window.markerclusterer.repaint();

        fitBoundsToVisibleMarkers();
      });
    }

    function fitBoundsToVisibleMarkers() {

      var bounds = new google.maps.LatLngBounds();

      $.each(window.markers, function (index, marker) {
        if (marker.getVisible()) {
          bounds.extend(marker.getPosition());
        }
      });

      window.mapAgencies.fitBounds(bounds);
    }

    function setMapAndList(agencies) {

      var icon = {
        path: "M23.5,0C11.3,0,0.2,9.9,0.2,22.2C0.2,34.4,10.3,49,23.5,70c13.2-21,23.3-35.6,23.3-47.8C46.8,9.9,35.7,0,23.5,0z M23.5,32.1c-4.8,0-8.7-3.9-8.7-8.8c0-4.8,3.9-8.8,8.7-8.8c4.8,0,8.7,3.9,8.7,8.8C32.2,28.2,28.3,32.1,23.5,32.1z",
        fillColor: '#000000',
        fillOpacity: 1,
        anchor: new google.maps.Point(28, 70),
        strokeWeight: 0,
        scale: 0.8
      };

      //reset markers
      window.markers = [];
      window.markerclusterer = new MarkerClusterer(window.mapAgencies, window.markers, {
        imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
        clusterClass: 'custom-clustericon',
        ignoreHidden: true
      });
      //window.markerclusterer.setIgnoreHidden(true);
      $('.sl-results-wrapper ul').html('');

      $.each(agencies, function (index, agence) {

        var agence = agence;
        var title = agence.title;
        var address = agence.address;
        var tel = agence.tel;
        var link = agence.link;
        var lat = agence.lat;
        var lng = agence.lng;

        var $html = $($('#template-agencies-list').html());
        $html.find('.cs-title').html(title);
        $html.find('.cs-address').html(address);
        $html.find('.cs-tel a').html(tel).attr('href', 'tel:' + tel);
        $html.find('.cs-link a').attr('href', link);

        textContents.push($html.text().toLowerCase());

        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(lat, lng),
          icon: icon,
          map: window.mapAgencies
        });

        window.markers.push(marker);

        bounds.extend(marker.position);

        google.maps.event.addListener(marker, 'click', function (marker, index) {
          return function () {
            infowindow.setContent($html.html());
            infowindow.open(window.mapAgencies, marker);
          };
        }(marker, index));

        google.maps.event.addListener(marker, 'visible_changed', function () {
          //console.log('marker '+index+' change detat :', marker.getVisible());
          if (marker.getVisible()) {
            window.markerclusterer.addMarker(marker, false);
            window.markerclusterer.repaint();
          } else {
            window.markerclusterer.removeMarker(marker, false);
            window.markerclusterer.repaint();
          }
        });

        //
        $('.sl-results-wrapper ul').append($html);
        window.markerclusterer.addMarkers(window.markers, true);
      });

      //console.log(textContents);

      window.mapAgencies.fitBounds(bounds);

      var oldCenter = window.mapAgencies.getCenter();
    }
  };

  var jsonDatas = [];
  var textContents2 = [];
  var bounds2;
  var infowindow2;
  $(document).ready(function () {
    bounds2 = new google.maps.LatLngBounds();
    infowindow2 = new google.maps.InfoWindow();
  });

  var map = function map() {
    $.ajax({
      type: 'POST',
      url: 'https://ups-access-point.herokuapp.com/ups-list',
      data: JSON.stringify({ "zipCode": "91300", "city": "", "country": "FR" }),
      headers: {
        "Content-Type": "application/json"
      },
      success: function success(response) {
        //console.log(response)
        for (var i = 0; i < 10; i++) {
          jsonDatas.push({ "title": response[i].name, "address": response[i].address, "lat": response[i].latitude, "lng": response[i].longitude });
        }
        console.log(jsonDatas);
        setMapAndList2(jsonDatas);
      },
      error: function error(_error) {
        console.log(_error);
      }
    });
  };

  $(document).ready(function () {
    map();
    initMap();
  });
}
"use strict";
'use strict';

// Click sur le select
$('body').on('click', '.select__custom--selected-value-container', function (e) {
  var forSelect = $(this).attr('for');
  if ($('.select__custom--values[for="' + forSelect + '"]').hasClass('opened')) {
    $(this).children('.icon--arrow-bottom').removeClass('opened');
    $('.select__custom--values[for="' + forSelect + '"]').removeClass('opened');

    if ($(this).hasClass('select-product') && window.matchMedia("(max-width: 767px)").matches) {
      $('#page__overlay--select-mobile').removeClass('opened');
    }
  } else {
    $(this).children('.icon--arrow-bottom').addClass('opened');
    $('.select__custom--values[for="' + forSelect + '"]').addClass('opened');

    console.log('passe select');
    if ($(this).hasClass('select-product') && window.matchMedia("(max-width: 767px)").matches) {
      $('#page__overlay--select-mobile').addClass('opened');
    }
  }

  $('.select__custom--values[for="' + forSelect + '"]').fadeToggle(50);

  //$('#page__overlay--white').addClass('opened')
});

$('body').on('click', '.select__custom--value', function (e) {
  var forSelect = $(this).attr('for');
  var value = $(this).attr('value');
  var valueText = $(this).text();
  //est ce quon a modifie un select via quick view
  var quickAdd = $(this).attr('product-grid') || "false";

  $('.icon--arrow-bottom').removeClass('opened');
  $('.select__custom--values').removeClass('opened');
  $('#page__overlay--select-mobile').removeClass('opened');

  if (forSelect == "sort--by") {
    if ($(this).hasClass('is__active')) {
      $('.select__custom--value[for="' + forSelect + '"]').removeClass('is__active');

      var url = new window.URL(window.location.href);
      var searchParams = new URLSearchParams(url.search);

      if (searchParams.has('sort_by')) {
        searchParams.delete('sort_by');
      }

      url.search = searchParams.toString();
      var urlWithoutSort = url.toString().replace('%2C', ',');

      if (history.replaceState) {
        window.history.replaceState({ path: urlWithoutSort }, '', urlWithoutSort);
      }

      var newUrl = urlWithoutSort + (url.search ? '&view=filtered' : '?view=filtered');

      console.log(urlWithoutSort + '&view=filtered');
      $.ajax({
        type: 'GET',
        url: newUrl,
        success: function success(content) {
          var count = parseInt(content.substring(0, 4));
          //$('.filter-count').text(count);
          $('#collection__list--container').remove();
          $('#collection__page--desktop').append(content);

          //clearFilter()
        },
        error: function error(_error) {
          console.log('erreur');
        }
      });
      $('.trierCount').hide();
    } else {
      $('.select__custom--value[for="' + forSelect + '"]').removeClass('is__active');
      $(this).addClass('is__active');

      $('.select__hidden[for="' + forSelect + '"]').val(value).trigger('change');
      $('.trierCount').show();
    }

    $('.select__custom--values').hide();
    $('.select__custom--values').removeClass('opened');
    $('#page__overlay--white').removeClass('opened');
    document.dispatchEvent(new CustomEvent('select-changed:' + forSelect, { 'detail': { quickAdd: quickAdd } }));
  } else {
    $('.select__custom--value[for="' + forSelect + '"]').removeClass('is__active');
    $(this).addClass('is__active');

    $('.select__custom--selected-value[name="' + forSelect + '"]').text(value);
    $('.product-sticky-buybox .select__custom--selected-value').text(value);
    $('.select__hidden[for="' + forSelect + '"]').val(value).trigger('change');
    $('.select__custom--values').hide();
    $('.select__custom--values').removeClass('opened');
    $('#page__overlay--white').removeClass('opened');
    document.dispatchEvent(new CustomEvent('select-changed:' + forSelect, { 'detail': { quickAdd: quickAdd } }));
  }
});

document.addEventListener('select-changed:sort--by', function (elem) {
  console.log('Select has changed');
}, false);

// Sort
Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
$('.select__hidden[for="sort--by"]').bind('change', function () {
  console.log('change sort by');
  Shopify.queryParams.sort_by = $(this).val();
  var filteredUrl = window.location.href;

  var url = new window.URL(window.location.href);
  console.log(url);
  url.searchParams.set("sort_by", Shopify.queryParams.sort_by);
  console.log(url.toString());

  filteredUrl = url.toString().replace(/%2C/g, ',');

  if (history.replaceState) {
    window.history.replaceState({ path: filteredUrl }, '', filteredUrl);
  }

  $.ajax({
    type: 'GET',
    url: filteredUrl + '&view=filtered',
    success: function success(content) {
      console.log(content);
      var count = parseInt(content.substring(0, 4));
      //$('.filter-count').text(count);
      $('#collection__list--container').remove();
      $('#collection__page--desktop').append(content);

      //clearFilter()
    },
    error: function error(_error2) {
      console.log('erreur');
    }
  });
});
'use strict';

/*var prevArrow = `<svg class="slick-arrow--left" viewBox="0 0 53.4 18.8"><defs><style>.cls-1{fill:#404040;}</style></defs><path class="cls-1" d="M0,9.3V10a.1.1,0,0,0,.1.1v.1h0l.1.1h0l10,8a1,1,0,0,0,1.2-1.6L3.6,10.5H51.9a.94.94,0,0,0,1-1,.94.94,0,0,0-1-1H3.8l7.8-6.2A1.08,1.08,0,0,0,11.8.9,1.23,1.23,0,0,0,11,.5a1.42,1.42,0,0,0-.6.2l-10,8h0l-.1.1h0v.1L.2,9C0,9.2,0,9.2,0,9.3Z"/></svg>`
var nextArrow = `<svg class="slick-arrow--right" x="0px" y="0px"viewBox="0 0 53.4 18.8" style="enable-background:new 0 0 53.4 18.8;" xml:space="preserve"> <style type="text/css"> .st0{fill:#404040;} </style> <path class="st0" d="M52.9,9.7V9.6V9.5c0,0,0,0,0-0.1s0,0,0-0.1V9.2V9.1V9c0,0,0-0.1-0.1-0.1V8.8l0,0l-0.1-0.1l0,0l-10-8 c-0.4-0.3-1.1-0.3-1.4,0.2C41,1.3,41,2,41.5,2.3l7.8,6.2H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h48.1l-7.8,6.2c-0.4,0.3-0.5,1-0.2,1.4 c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2l10-8l0,0l0.1-0.1l0,0v-0.1l0.1-0.1C52.9,9.8,52.9,9.8,52.9,9.7z"/> </svg>`*/

var prevArrow = '<svg class="slick-arrow--left" x="0px" y="0px"viewBox="0 0 11.477 17.609" style="enable-background:new 0 0 53.4 18.8;" xml:space="preserve"><g transform="translate(1.41 1.41)"><line style="fill:none;stroke:#494949;stroke-linecap:round;stroke-width:2px;" x1="8.657" y2="7.395"/><line style="fill:none;stroke:#494949;stroke-linecap:round;stroke-width:2px;" x2="8.657" y2="7.395" transform="translate(0 7.395)"/></g></svg>';
var nextArrow = '<svg class="slick-arrow--right" x="0px" y="0px"viewBox="0 0 11.477 17.609" style="enable-background:new 0 0 53.4 18.8;" xml:space="preserve"><g transform="translate(10.067 16.199) rotate(180)"><line style="fill:none;stroke:#494949;stroke-linecap:round;stroke-width:2px;" x1="8.657" y2="7.395"/><line style="fill:none;stroke:#494949;stroke-linecap:round;stroke-width:2px;" x2="8.657" y2="7.395" transform="translate(0 7.395)"/></g></svg>\n';

var initSlick = function initSlick() {
  /*if (window.matchMedia("(max-width: 767px)" ).matches) {
    $('.announcement-slider').slick({
      slidesToShow: 1,
      variableWidth: true,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 8000,
      pauseOnHover: false,
      cssEase: 'linear',
      dots: false,
      infinite: true,
      arrows: false
    });
  }*/

  if (window.general.sliderAuto == true && window.general.homePage == true) {
    if (window.slider.autoplay != "") {
      $('.slider-home-new').slick({
        dots: false,
        infinite: true,
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: window.slider.autoplay
      });
    }
  }

  $('.slider-footer').slick({
    slidesToShow: 1,
    variableWidth: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: 'linear',
    dots: false,
    infinite: true,
    arrows: false
  });

  $('.background-slider').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000
  });

  $('.carousel-product-list').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1100,
      settings: {
        arrows: false,
        dots: true,
        customPaging: function customPaging(slider, i) {
          return '<button class="tab"></button>';
        }
      }
    }, {
      breakpoint: 950,
      settings: {
        slidesToShow: 3,
        arrows: false,
        dots: true,
        customPaging: function customPaging(slider, i) {
          return '<button class="tab"></button>';
        }
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        arrows: false,
        dots: true,
        customPaging: function customPaging(slider, i) {
          return '<button class="tab"></button>';
        }
      }
    }]
  });

  $('.blog-slider').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('.slider-infos-product').slick({
    dots: true,
    customPaging: function customPaging(slider, i) {
      return '<button class="tab"></button>';
    },
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000
  });

  $('.slider-cart').slick({
    dots: true,
    customPaging: function customPaging(slider, i) {
      return '<button class="tab"></button>';
    },
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true
  });

  $('#instagram-feed').slick({
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 5
      }
    }, {
      breakpoint: 950,
      settings: {
        slidesToShow: 1,
        variableWidth: true
      }
    }]
  });
};

initSlick();

document.addEventListener('theme-editor--slick', function (e) {
  $('.background-slider').filter('.slick-initialized').slick('unslick');
  $('.carousel-product-list').filter('.slick-initialized').slick('unslick');
  $('.blog-slider').filter('.slick-initialized').slick('unslick');
  $('#instagram-feed').filter('.slick-initialized').slick('unslick');
  $('#bandeau--footer-slider').filter('.slick-initialized').slick('unslick');

  initSlick();
}, false);

$(window).on('load', function () {
  $('#announcement__bar--container .text-slide').css('opacity', '1');
});
'use strict';

var announcementDetails = {};
if ($('[announcement-details]').html()) {
  announcementDetails = JSON.parse($('[announcement-details]').html());
}

var text_ecran = announcementDetails.text_ecran;
var text_mobile = announcementDetails.text_mobile;
var lien_ecran = announcementDetails.lien_ecran;
var lien_mobile = announcementDetails.lien_mobile;
var counter = 1;
var elem = $("#annonce");

if (window.matchMedia("(min-width: 767px)").matches) {
  var change = function change() {
    if (text_ecran && text_ecran.length > 1) {
      elem.fadeOut(function () {
        elem.html(text_ecran[counter]);
        if (lien_ecran[counter] != "unlink") {
          elem.attr("href", lien_ecran[counter]);
        } else {
          elem.removeAttr('href');
        }
        counter++;
        if (counter >= text_ecran.length) {
          counter = 0;
        }
        elem.fadeIn();
      });
    }
  };

  if (lien_ecran && lien_ecran[0] != "unlink") {
    elem.attr("href", lien_ecran[0]);
  } else {
    elem.removeAttr('href');
  }
  setInterval(change, 6000);
} else {
  /*if(lien_ecran && lien_mobile[0] != "unlink"){
    elem.attr("href", lien_mobile[0]);
  } else{
    elem.removeAttr('href');
  }
   text_mobile ? elem.html(text_mobile[0]) : null;
  setInterval(change, 3000);
    function change() {
      if(text_mobile && text_mobile.length > 1){
        elem.fadeOut(function(){
            elem.html(text_mobile[counter]);
            if(lien_mobile[counter] != "unlink"){
              elem.attr("href", lien_mobile[counter]);
            } else{
              elem.removeAttr('href');
            }
            counter++;
            if(counter >= text_mobile.length) { counter = 0; }
            elem.fadeIn();
        });
      }
    }*/
}
'use strict';

if (window.matchMedia("(max-width: 767px)").matches) {
  $('#sidebar-accordion-footer .plus__icon').show();
  $('#sidebar-accordion-footer').find('li.extend').click(function (e) {
    $(this).children('.extended-submenu').slideToggle('fast');
    $(this).children('.nav__footer--title').children('.plus__icon').toggleClass('opened');
    $(this).toggleClass('active');
  });
}

$(window).on('resize', function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('#sidebar-accordion-footer .extended-submenu').hide();
  }
  if (window.matchMedia("(min-width: 768px)").matches) {
    $('#sidebar-accordion-footer .extended-submenu').show();
  }
});
'use strict';

var pageOverlayOpened = false;
$(".navigation__item--link-megamenu").mouseenter(function () {
  if (pageOverlayOpened == false) {
    $('#page__overlay--navigation').addClass('opened');
    pageOverlayOpened = true;
  }
});

$(".navigation__item--link-megamenu").mouseleave(function () {
  if (pageOverlayOpened == true) {
    $('#page__overlay--navigation').removeClass('opened');
    pageOverlayOpened = false;
  }
});

// Gestion de la hauteur du drawer sur mobile
// a utiliser si le drawer ne fait pas 100% de l'ecran, sinon on peut commenter
if ($(document).scrollTop() > 20) {
  var navbarHeightMobile = 40;
} else {
  var navbarHeightMobile = 74;
}
$('#navigation__drawer').css('height', window.innerHeight - navbarHeightMobile); // init
$(document).on('scroll', function () {
  if ($(document).scrollTop() > 20) {
    var navbarHeightMobile = 40;
  } else {
    var navbarHeightMobile = 74;
  }
  $('#navigation__drawer').css('height', window.innerHeight - navbarHeightMobile);
});

$('.parent').on('click', function () {
  var menu = $(this).attr('for');
  $('.parent.is-active').removeClass('is-active');
  $('.parent[for="' + menu + '"]').addClass('is-active');

  /*var CookieDate = new Date;
  CookieDate.setMonth(CookieDate.getMonth() + 12);
  document.cookie = "favorite-menu=" + menu + "; expires=" + CookieDate.toGMTString() + "; path=/";*/
  $('.menu--container.is-active').hide();
  $('.menu--container').removeClass('is-active');
  $('.menu--container[for="' + menu + '"]').fadeIn(400);
  $('.menu--container[for="' + menu + '"]').addClass('is-active');
});

$('.panier-nav-drawer').on('click', function () {
  $('#navigation__drawer--header .close').click();
  setTimeout(function () {
    $('.button__action--cart-preview').click();
  }, 500);
});
'use strict';

var whiteNavBar = function whiteNavBar() {
  $('#main__logo--svg').removeClass('logo--white');
  $('.link--text-style').removeClass('white');
  $('#icon-account .icon--compte').removeClass('logo--white');
  $('#icon-cart .icon--panier').removeClass('logo--white');
  $('#icon-cart .items--count').removeClass('white');
  $('#icon-search .icon--recherche').removeClass('logo--white');
  $('#icon-underline .icon--soulignement').removeClass('logo--white');
};

var transparentNavbar = function transparentNavbar() {
  $('#main__logo--svg').addClass('logo--white');
  $('.link--text-style').addClass('white');
  $('#icon-account .icon--compte').addClass('logo--white');
  $('#icon-cart .icon--panier').addClass('logo--white');
  $('#icon-cart .items--count').addClass('white');
  $('#icon-search .icon--recherche').addClass('logo--white');
  $('#icon-underline .icon--soulignement').addClass('logo--white');
};

var handleBarChange = function handleBarChange() {
  if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
    $("#navigation--container").addClass('transparent--nav');
    transparentNavbar();
  }
};
// window.location.pathname == "/" ||
if (window.general.headerTransparent == 1) {
  if (window.location.href.indexOf("product") > -1) {
    if (window.matchMedia("(min-width: 1101px)").matches) {

      if ($(document).scrollTop() < 20) {
        if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
          $("#navigation--container").addClass('transparent--nav');
        }
        $('#navigation--container').mouseenter(function () {
          $(this).removeClass('transparent--nav');
        });

        $('#navigation--container').mouseleave(function () {
          if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
            $("#navigation--container").addClass('transparent--nav');
          }
        });
      }

      if ($(document).scrollTop() > 20) {
        $("#navigation--container").removeClass('transparent--nav');
        $("#navigation--container").addClass('scrolled--nav');
      }

      $(document).on('scroll', function () {
        if ($(document).scrollTop() > 20) {
          $("#navigation--container").removeClass('transparent--nav');
          $("#navigation--container").addClass('scrolled--nav');
        } else {
          if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
            $("#navigation--container").addClass('transparent--nav');
          }
          $("#navigation--container").removeClass('scrolled--nav');

          $('#navigation--container').mouseleave(function () {
            if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
              $("#navigation--container").addClass('transparent--nav');
            }
          });
        }
      });
    }
  } else {
    if (window.matchMedia("(min-width: 1101px)").matches) {

      if ($(document).scrollTop() < 20) {
        if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
          $("#navigation--container").addClass('transparent--nav');
        }
        $('#navigation--container').mouseenter(function () {
          $(this).removeClass('transparent--nav');
          whiteNavBar();
        });

        $('#navigation--container').mouseleave(function () {
          handleBarChange();
        });
      } else {
        $("#navigation--container").removeClass('transparent--nav');
        $("#navigation--container").addClass('scrolled--nav');
        whiteNavBar();
      }

      $(document).on('scroll', function () {
        if ($(document).scrollTop() > 20) {
          $("#navigation--container").removeClass('transparent--nav');
          $("#navigation--container").addClass('scrolled--nav');
          whiteNavBar();

          $('#navigation--container').mouseleave(function () {
            whiteNavBar();
          });
        } else {
          handleBarChange();

          $("#navigation--container").removeClass('scrolled--nav');
          $('#navigation--container').mouseleave(function () {
            handleBarChange();
          });
        }
      });
    }
  }
}

// Gestion de la hauteur du drawer sur mobile
// a utiliser si le drawer ne fait pas 100% de l'ecran
if ($(document).scrollTop() > 20) {
  var navbarHeightMobile = 0;
} else {
  var navbarHeightMobile = 0;
}
$('#navigation__drawer').css('height', window.innerHeight - navbarHeightMobile); // init
$(document).on('scroll', function () {
  if ($(document).scrollTop() > 20) {
    var navbarHeightMobile = 0;
  } else {
    var navbarHeightMobile = 0;
  }
  $('#navigation__drawer').css('height', window.innerHeight - navbarHeightMobile);
});

$(document).on('scroll', function () {
  var height = window.innerHeight ? window.innerHeight : $(window).height();
  $('#navigation__drawer').height(height);
});

// Gestion du scroll
if (window.matchMedia("(max-width: 1100px)").matches) {
  if ($(document).scrollTop() > 20) {
    $('#navigation__drawer').addClass('scroll-drawer');
  } else {
    $('#navigation__drawer').removeClass('scroll-drawer');
  }
  $(document).on('scroll', function () {
    if ($(document).scrollTop() > 20) {
      $('#navigation__drawer').addClass('scroll-drawer');
    } else {
      $('#navigation__drawer').removeClass('scroll-drawer');
    }
  });
}
"use strict";

if (window.location.href.indexOf("blog") > -1 || window.location.href.indexOf("article") > -1) {
  $('#icon-search-blog, #icon-search-blog-2').on('click', function () {
    if ($('.search--container').hasClass('opened-blog')) {
      $('.search--container').removeClass('opened-blog');
      $('.searchArticle').val('');
      $(".result-search").html('');
      $('#page__overlay--navigation').removeClass('opened');
    } else {
      $('#page__overlay--navigation').addClass('opened');
      $('.search--container').addClass('opened-blog');
      $('.searchArticle.search--input').focus();
    }
  });

  var handleCloseSearch = function handleCloseSearch() {
    $('.searchArticle').val('');
    $(".result-search").html('');
    $('.search--container').removeClass('opened-blog');
    $('.search--container').css('transform', '');
  };

  $('.close--search').on('click', function () {
    handleCloseSearch();
  });

  $(document).on('click', function (e) {

    var container = $(".search--container");
    var container2 = $(".search--container-barre");
    if ($(e.target).hasClass('search--trigger')) {} else {
      if (container.hasClass('opened-blog') && !container.is(e.target) && container.has(e.target).length === 0) {
        handleCloseSearch();
      }
    }

    if (!container2.is(e.target) && container2.has(e.target).length === 0) {
      $('.searchArticle-barre').val('');
      $('.result-search-barre').html('');
    }
  });
} else {
  var handleSearchBar = function handleSearchBar(searchTriggerId, positionScrolledClass, positionClass, translateYScrolled, translateY) {
    $(searchTriggerId).on('click', function () {
      ga('send', 'event', 'Action site', 'Recherche', 'Recherche');
      if ($('.search--container').hasClass(positionScrolledClass) || $('.search--container').hasClass(positionClass)) {
        $('#page__overlay--navigation').removeClass('opened');
        $('.navigation__item--container').removeClass('search--opened');
        $('#navigation--container').removeClass('fixedWhiteNav');
        $('.search--container').removeClass(positionScrolledClass + " " + positionClass);
        $('.search--container').css('transform', '');
        $('.searchProduct').val('');
        $(".result-search").html('');
        $(".popular_product").removeClass('opened');
      } else {
        $('#page__overlay--navigation').addClass('opened');
        $('.navigation__item--container').addClass('search--opened');
        $('#navigation--container').addClass('fixedWhiteNav');
        $('#navigation--container').removeClass('transparent--nav');
        $(".popular_product").addClass('opened');
        if ($(document).scrollTop() >= 20) {
          $('.search--container').addClass(positionScrolledClass);
        } else {
          var topPosition = translateY - $(document).scrollTop();
          $('.search--container').addClass(positionClass);
          $(".search--container." + positionClass + ", .search--container." + positionScrolledClass).css('transform', "translateY(" + topPosition + "px)");
        }
      }
      $('.searchProduct.search--input').focus();
    });

    $(document).on('scroll', function () {
      if ($(document).scrollTop() >= 20) {
        $(".search--container." + positionClass + ", .search--container." + positionScrolledClass).css('transform', "translateY(" + translateYScrolled + "px)");
      } else {
        var topPosition = translateY - $(document).scrollTop();
        $(".search--container." + positionClass + ", .search--container." + positionScrolledClass).css('transform', "translateY(" + topPosition + "px)");
      }
    });
  };

  if (window.matchMedia("(max-width: 767px)").matches) {
    handleSearchBar('#icon-search-mobile', 'opened-mobile-scroll', 'opened-mobile2', 450, 478);
  } else if (window.matchMedia("(max-width: 1100px)").matches) {
    handleSearchBar('#icon-search-mobile', 'opened-mobile-scroll', 'opened-mobile', 450, 492);
  } else {
    handleSearchBar('#icon-search', 'opened-scroll', 'opened', 499, 541);
  }

  var handleCloseSearch = function handleCloseSearch() {
    $('.searchProduct').val('');
    $(".result-search").html('');
    $('.popular_product').removeClass('opened');
    $('.search--container').removeClass('opened opened-scroll opened-mobile-scroll opened-mobile opened-mobile2');
    $('.search--container').css('transform', '');
    $('#navigation--container').removeClass('fixedWhiteNav');
    $('#page__overlay--navigation').removeClass('opened');
    $('.navigation__item--container').removeClass('search--opened');
  };

  $('.close--search').on('click', function () {
    handleCloseSearch();
  });

  $(document).on('click', function (e) {

    var container = $(".search--container");
    if ($(e.target).hasClass('search--trigger')) {} else {
      if ((container.hasClass('opened') || container.hasClass('opened-mobile') || container.hasClass('opened-mobile2')) && !container.is(e.target) && container.has(e.target).length === 0) {
        handleCloseSearch();
      }
    }
  });

  $(document).on('click', '.global-search', function () {
    //var url = window.location.hostname
    var search = document.getElementsByClassName('searchProduct')[0].value;
    if (window.general.langue != 'fr') {
      var redirection = "/" + window.general.langue + "/search?type=product&q=" + search;
    } else {
      var redirection = "/search?type=product&q=" + search;
    }

    window.location.replace(redirection);
    $('.search--container').removeClass('opened');
  });
}

$(document).on('input', '.search--input', function () {
  if ($(this).attr('search') === 'barre') {
    SearchFunction('searchArticle-barre', 'article', 'result-search-barre');
  } else if ($(this).attr('search') === 'article') {
    SearchFunction('searchArticle', 'article', 'result-search');
  } else if ($(this).attr('search') === 'produit') {
    SearchFunction('searchProduct', 'product', 'result-search');
  }
});

var SearchFunction = function SearchFunction(classInput, typeSearch, classInputResult) {

  var htmlItem = function htmlItem(type, item) {
    if (type == "article") {
      return "<div class='one-product'><a class='flex fd--column jc--flex-start' href=" + item[i].url + "><img class='image-product' src=" + item[i].image + "><div class='content--container flex fd--column ai--flex-start'><p class='product--title fw--700 black text__center'>" + item[i].title + "</p></div></a></div>";
    } else {
      if (item[i].compare_at_price_max == 0.00) {
        var prix = item[i].price.replace('.', ',') + '€';
      } else {
        var prix = item[i].price.replace('.', ',') + "€<span class='reduction line__through '>" + item[i].compare_at_price_max.replace('.', ',') + "€</span>";
      }
      return " <div class='one-product'><a class='flex fd--column jc--flex-start' href=" + item[i].url + "><img class='image-product' src=" + item[i].image + "><div class='content--container flex fd--column'><p class='product--title fw--700 black'>" + item[i].title + "</p><p class='price product--title black'>" + prix + "</p></div></a></div>";
    }
  };

  var emptyItem = function emptyItem(type) {
    if (type == "article") {
      return "<div class='empty'>Aucun article ne correspond à votre recherche</div>";
    } else {
      return "<div class='empty'>Aucun produit ne correspond à votre recherche</div>";
    }
  };

  var q = document.getElementsByClassName(classInput)[0].value;
  var b = "&resources[type]=" + typeSearch;
  var c = '';
  console.log(q);

  if (q == "") {
    $(".result-search").html('');
    $(".result-search-barre").html('');
  }
  if (typeSearch == 'article') {
    var type = "article";
  } else {
    var type = "product";
    c = '&resources[options][fields]=title,product_type,tag';
    if (q == "") {
      $(".popular_product").addClass('opened');
    } else {
      $(".popular_product").removeClass('opened');
    }
  }
  if (window.general.langue != 'fr') {
    var first = "/" + window.general.langue + "/search/suggest.json?q=";
  } else {
    var first = '/search/suggest.json?q=';
  }
  console.log(first);
  $.ajax(first + q + b + c, {
    type: 'GET',
    dataType: 'json',
    success: function success(response) {
      gtag('event', 'search_custom', {
        'label': q
      });
      var itemsSuggestions = response.resources.results[typeSearch + "s"];
      if (itemsSuggestions.length > 0) {
        var result = "";
        for (i = 0; i < itemsSuggestions.length; i++) {
          if (itemsSuggestions[i].id != 6623214993579 && itemsSuggestions[i].id != 6623216205995) {
            result += htmlItem(type, itemsSuggestions);
          }
        }

        if (type == "product") {
          result = result + "<div class='global-search '>Plus de résultats</div>";
        }
        $("." + classInputResult).html(result);
      } else {
        var emptyProduct = emptyItem(type);
        $("." + classInputResult).html(emptyProduct);
      }
    }
  });
};

$('#search--container-mobile-drawer').on('click', function () {
  $('#navigation__drawer--header').find('.close').click();
  setTimeout(function () {
    $('#icon-search-mobile').click();
  }, 200);
});
'use strict';

$('.faq__q__and__a').on('click', function () {
  $('.arrow-bottom').attr('arrow-open', 'false');
  var $question = $(this).children('.faq__question');
  $('.plus__icon').removeClass('opened');
  $(this).find('.plusminus').toggleClass('active');
  $question.children('.plus__icon').toggleClass('opened');
  if ($question.next().attr('aria-hidden') == 'false') {
    $question.next().slideToggle(200).attr('aria-hidden', 'true');
    $(this).find('span').attr('arrow-open', 'false');
    $('.plus__icon').removeClass('opened');
  } else {
    $('.faq__q__and__a').find('.faq__answer[aria-hidden="false"]').not($question).slideToggle(200).attr('aria-hidden', 'true');
    $question.next().slideToggle(200).attr('aria-hidden', 'false');
    $(this).find('span').attr('arrow-open', 'true');
  }
});

$('.faq-link').on('click', function () {
  //$('.faq-link').removeClass('active-link')
  //$(this).addClass('active-link')
  var block = $(this).attr('link');
  $('html, body').animate({
    scrollTop: $(block).offset().top - 150
  }, 500);
});
'use strict';

$('#close-article-page').on('click touchend', function () {
  $('#article-page-overlay').hide();
});
$(document).mouseup(function (e) {
  var container = $("#article-page");
  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('#article-page-overlay').hide();
  }
});
$('.article').on('click touchend', function () {
  var background_url = "https:" + $(this).attr('background-img');
  $('#click-contain img').attr('src', background_url);
  $('#article-page-overlay').show().css('display', 'flex');
});
'use strict';

if (window.matchMedia("(min-width: 1001px)").matches) {
  var container = [];

  $('#slider--product').find('.swiper-slide').each(function () {

    var $link = $(this).find('.product__image-swipe'),
        item = {
      src: $link.attr('src'),
      w: $link.attr('width'),
      h: $link.attr('height')
    };
    container.push(item);
  });

  var gallery = '';
  // Define click event on gallery item
  $('body').on('click', '#slider--product .swiper-slide', function (event) {

    // Prevent location change
    event.preventDefault();

    // Define object and gallery options
    var $pswp = $('.pswp')[0],
        options = {
      index: $(this).index(),
      closeOnScroll: false
    };
    console.log($pswp);
    //console.log($(this))

    // Initialize PhotoSwipe
    gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, container, options);
    gallery.init();

    if (window.matchMedia("(max-width: 1000px)").matches) {
      $('#slider--product').find('.swiper-slide').each(function () {
        var id = $(this).attr('id');
        if (id !== undefined) {
          console.log(id);
          console.log($(this));
          $(this).find('.product__image-swipe').clone().appendTo(".pswp__thumbnail");
        }
      });
    } else {
      $('#slider--product img').clone().appendTo(".pswp__thumbnail");
    }

    $('.button-pswp--container, .pswp__thumbnail').addClass('opened');

    $(".pswp__thumbnail img").eq(gallery.getCurrentIndex()).addClass('active');

    gallery.listen('close', function () {
      $(".pswp__thumbnail img").remove();
      $('.button-pswp--container, .pswp__thumbnail').removeClass('opened');
    });
  });

  $('body').on('click', '.pswp__thumbnail img', function (e) {
    $('.pswp__thumbnail img').removeClass("active");
    $(this).addClass('active');

    var number = $(".pswp__thumbnail img").index($(this));
    console.log(number);
    console.log(gallery);
    gallery.goTo(number);

    $('.button-zoom-pswp').children('.see-more').removeClass('opened');
  });

  $('body').on('click', '.button-close-pswp', function () {
    gallery.close();
  });

  $('body').on('click', '.button-zoom-pswp', function () {
    gallery.toggleDesktopZoom();
    if ($('.pswp').hasClass('pswp--zoomed-in')) {
      $('.button-zoom-pswp').children('.see-more').addClass('opened');
    } else {
      $('.button-zoom-pswp').children('.see-more').removeClass('opened');
    }
  });

  $('body').on('click', '.pswp__img', function () {
    if ($('.pswp').hasClass('pswp--zoomed-in')) {
      $('.button-zoom-pswp').children('.see-more').addClass('opened');
    } else {
      $('.button-zoom-pswp').children('.see-more').removeClass('opened');
    }
  });
};
'use strict';

$('ul.sidebar-accordion').find('li.extend').click(function () {
  $('li.extend.active').not($(this)).toggleClass('active');
  //Expand or collapse this panel
  $(this).next().slideToggle('fast');
  $(this).toggleClass('active');
  //Hide the other panels
  $("ul.extended-submenu").not($(this).next()).slideUp('fast');
});

$('#moreDetails').on('click', function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('html, body').animate({
      scrollTop: $(".ProductDescription--mobile-container").offset().top - 140
    }, 600);
  } else {
    $('html, body').animate({
      scrollTop: $(".ProductDescription").offset().top - 200
    }, 600);
  }
});

$('.tabs').each(function () {
  var active,
      content,
      links = $(this).find('a');
  active = links.first().addClass('active');
  content = $(active.attr('href'));
  links.not(':first').each(function () {
    $($(this).attr('href')).hide();
  });
  $(this).find('a').click(function (e) {
    active.removeClass('active');
    content.hide();
    active = $(this);
    content = $($(this).attr('href'));
    active.addClass('active');
    content.show();
    return false;
  });
});

$('#details__anchor').on('click', function () {
  var id = $(this).attr('href');

  $('html, body').animate({
    scrollTop: $(id).offset().top - 150
  }, 500);
});
'use strict';

if (window.matchMedia("(max-width: 1000px)").matches) {
  /*$('#slider--product').slick({
    dots: true,
    customPaging: function(slider, i) {
      return '<button class="tab"></button>';
    },
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });*/
}

$('#slider--product').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  $('#slider__nav--product .carousel-cell').removeClass('is-nav-selected');
  $('#slider__nav--product .carousel-cell[thumb-index="' + nextSlide + '"]').addClass('is-nav-selected');
});

$('#slider__nav--product .carousel-cell').on('click', function () {
  var index = $(this).attr('thumb-index');
  $('#slider__nav--product .carousel-cell').removeClass('is-nav-selected');
  $(this).addClass('is-nav-selected');
  $('#slider--product').slick('slickGoTo', index);
});

if (window.matchMedia("(min-width: 1001px)").matches) {
  $('body').on('click', '.swiper-zoom-container', function () {
    $(this).toggleClass('zoom-container');
  });
  $('body').on('mouseleave', '.swiper-zoom-container', function () {
    $(this).removeClass('zoom-container');
  });
}
'use strict';

var productDetails = {};
if ($('[product-details]').html()) {
  productDetails = JSON.parse($('[product-details]').html());
}

$('.quantity__change--selector-product').on('click', function () {
  var type = $(this).attr('type');
  var currentQty = parseInt($('.product__qty--container .quantity__current').val());

  if (type == 'minus') {
    if (currentQty != 0) {
      $('.product__qty--container .quantity__current').val(currentQty - 1);
    }
  } else {
    $('.product__qty--container .quantity__current').val(currentQty + 1);
  }
});

document.addEventListener('select-changed:product__option--1', function (event) {
  if (event.detail.quickAdd == "true") {
    onOptionChangedQuickAdd();
  } else {
    onOptionChanged();
  }
}, false);
document.addEventListener('select-changed:product__option--2', function (event) {
  if (event.detail.quickAdd == "true") {
    onOptionChangedQuickAdd();
  } else {
    onOptionChanged();
  }
}, false);
document.addEventListener('select-changed:product__option--3', function (event) {
  if (event.detail.quickAdd == "true") {
    onOptionChangedQuickAdd();
  } else {
    onOptionChanged();
  }
}, false);

// Change variant for bulles
$('.bulle__custom--value').on('click', function () {
  var value = $(this).text();
  var option = $(this).attr('for');

  $('.select__custom--selected-value[for="' + option + '"]').text(value);
  $('.bulle__custom--value[for="' + option + '"]').removeClass('is__active');
  $(this).addClass('is__active');

  document.dispatchEvent(new CustomEvent('select-changed:' + option, { 'detail': { quickAdd: "false" } }));
});

function updateProductButton(variant, productId) {
  var price = parseFloat(variant.price.replace('€', ''));
  var compareAtPrice = parseFloat(variant.compareAtPrice.replace('€', ''));

  var addToCart = $('.add__to__cart[product-id="' + productId + '"]');
  var addToCartSticky = $('.product-sticky-buybox__add-to-cart');

  if (variant.available == 0) {
    var textButton = '';
    if (window.matchMedia("(max-width: 767px)").matches) {
      if (window.location.pathname.match(/^\/en/)) {
        textButton = 'Be alerted';
      } else {
        textButton = 'Être alerté';
      }
    } else {
      if (window.location.pathname.match(/^\/en/)) {
        textButton = 'Receive an alert';
      } else {
        textButton = 'Recevoir une alerte';
      }
    }

    addToCart.html(textButton);
    addToCartSticky.html(textButton);

    addToCart.addClass('klaviyo-bis-trigger');
    addToCart.attr('variant-available', false);
    addToCart.attr('data-variant-id', variant.id);

    addToCartSticky.addClass('klaviyo-bis-trigger');
    addToCartSticky.attr('variant-available', false);
    addToCartSticky.attr('data-variant-id', variant.id);
  } else {
    addToCart.removeClass('klaviyo-bis-trigger');
    addToCart.attr('variant-available', true);

    addToCartSticky.removeClass('klaviyo-bis-trigger');
    addToCartSticky.attr('variant-available', true);

    var textButton = '';
    if (window.matchMedia("(max-width: 767px)").matches) {
      if (window.location.pathname.match(/^\/en/)) {
        textButton = 'Add';
      } else {
        textButton = 'Ajouter';
      }
    } else {
      if (window.location.pathname.match(/^\/en/)) {
        textButton = 'Add to cart';
      } else {
        textButton = 'Ajouter au panier';
      }
    }

    addToCart.html(textButton);
    addToCartSticky.html(textButton);
  }
}

function onOptionChanged() {
  var productOptions = [];

  for (var i = 1; i <= 3; i++) {
    productOptions[i - 1] = $('.select__custom--selected-value[product-id="' + productDetails.productId + '"][name="product__option--' + i + '"]').text().trim() || "";
  }
  if (productDetails && productDetails.variants.length >= 1) {
    productDetails.variants.forEach(function (variant) {
      if (variant.option1 == productOptions[0] && variant.option2 == productOptions[1] && variant.option3 == productOptions[2]) {

        var lastPiece = productDetails.numberLastPieces;
        var piece = variant.availableQty;
        var stockPiece = productDetails.stockProduct;
        var tag = $('.tag-product').attr('tag');

        if (window.location.pathname.match(/^\/en/)) {
          var epuise = 'Sold out';
          var lastPieces = 'Last pieces';
        } else {
          var epuise = 'Épuisé';
          var lastPieces = 'Dernières pièces';
        }

        if (parseInt(piece) == 0) {
          if ($('.tag-product').hasClass('display__none')) {
            $('.tag-product').removeClass('display__none');
          }
          $('.tag-product').text(epuise).removeClass('product__tags--item last-pieces white').addClass('black');
          $('.delivery--container').hide();
        } else if (parseInt(stockPiece) < parseInt(lastPiece)) {
          if ($('.tag-product').hasClass('display__none')) {
            $('.tag-product').removeClass('display__none');
          }
          $('.tag-product').text(lastPieces).removeClass('black').addClass('last-pieces white');
          $('.delivery--container').show();
        } else if (tag) {
          if ($('.tag-product').hasClass('display__none')) {
            $('.tag-product').removeClass('display__none');
          }
          $('.tag-product').text(tag).removeClass('black').addClass('last-pieces white');
          $('.delivery--container').show();
        } else {
          $('.tag-product').addClass('display__none');
          $('.delivery--container').show();
        }

        var value = $(this).attr('value');
        console.log(value);
        $('.select__custom--selected-value').text(value);
        //$('.product--price').text(variant.price)
        //$('.product--compare-at-price').text(variant.compareAtPrice)
        $('.add__to__cart[product-id="' + productDetails.productId + '"]').attr('variant-id', variant.id);
        var url = document.location.origin + document.location.pathname + ('?variant=' + variant.id);
        window.history.replaceState({ path: url }, '', url);
        var featuredImage = variant.imageId;

        // Change image on variant change
        var imageNumber = parseInt($('#slider--product .product__image[image-id="' + featuredImage + '"]').attr("slide-number")) - 1;
        if (imageNumber) {
          $('#slider--product').slick('slickGoTo', imageNumber);
        }

        updateProductButton(variant, productDetails.productId);
      }
    });
  }
}

$('.one-infos .title--container').on('click', function () {
  var link = $(this).attr('link');
  if ($(this).hasClass('opened')) {
    $(this).removeClass('opened');
    $(this).children('.plus__icon').removeClass('opened');
    $('.infos--container[link="' + link + '"]').slideToggle(200).removeClass('opened');
  } else {
    $(this).addClass('opened');
    $(this).children('.plus__icon').addClass('opened');
    $('.infos--container[link="' + link + '"]').slideToggle(200).addClass('opened');
  }
});

$(document).on('click', function (e) {
  var product = $(".values-product");
  var product2 = $(".select-product");
  if (product.is(e.target) || product2.is(e.target)) {} else {
    if (product.hasClass('opened')) {
      $(".values-product.opened").fadeToggle(50);
      product.removeClass('opened');
      $('.select__custom--selected-value-container').children('.icon--arrow-bottom').removeClass('opened');
    }
  }
});

/*$('body').on('click', '.one-color', function(e){
  e.preventDefault();

  var link = $(this).attr('link')

  window.location = link
})*/

if (window.matchMedia("(max-width: 1000px)").matches) {
  var galleryTop = new Swiper('#slider--product', {
    zoom: {
      maxRatio: 3
    },
    effect: 'fade',
    fade: { crossFade: true },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    loop: true,
    on: {
      click: function click(e) {

        if (galleryTop.zoom.scale == 1) {
          $('.swiper-zoom-container').css('cursor', 'crosshair');
          $('.product__tags--container').hide();
          galleryTop.zoom.in();
        } else {
          $('.swiper-zoom-container').css('cursor', 'zoom-in');
          $('.product__tags--container').show();
          galleryTop.zoom.out();
        }
      },
      slideChangeTransitionStart: function slideChangeTransitionStart(event) {
        if ($('.swiper-slide-active').find('#video-slider-product').length > 0) {
          $('.video-product-gallery--container').show();
        } else {
          $('.video-product-gallery--container').hide();
        }
        var slideNumber = $('.swiper-slide-active .product__image').attr('slide-number');
        $('#swiper__product__thumb .thumb--element').removeClass('active__slide');
        $('#swiper__product__thumb .thumb--element[data-slider="' + slideNumber + '"]').addClass('active__slide');
      }
    }
  });

  if (window.product && window.productGallery && window.productGallery.zoom == false && window.location.pathname != "/products/gift-card") {
    galleryTop.zoom.disable();
  }
}

if (window.location.href.indexOf("/products/") > -1) {
  var id = productDetails.productId;
  fetch(window.Shopify.routes.root + ('recommendations/products.json?product_id=' + id + '&limit=4')).then(function (response) {
    return response.json();
  }).then(function (_ref) {
    var products = _ref.products;

    if (products.length > 0) {
      for (var i = 0; i <= 3; i++) {
        var price = products[i].price / 100;
        var priceFinal = price.toFixed(0) + "€";

        var comparePrice = products[i].compare_at_price / 100;
        if (comparePrice == 0) {
          var comparePriceFinal = "";
        } else {
          var comparePriceFinal = comparePrice.toFixed(0) + "€";
        }

        $('.product-reco-auto').append('<div class="product__item--container product-reco' + i + '">\n          <div class="sales__tag--container position__relative mhu--0-25 margin__right--none">\n            <p class=" text__center position__relative black product--title width--100 sales">\n\n            </p>\n          </div>\n\n          <a class="product__item__link--container product-reco-link--container" href="' + products[i].url + '" style="z-index: 2;">\n\n            <div class="position__relative product__item__image--container background__light__color">\n              <img class="product__item__image margin__auto flex " loading="lazy" src="' + products[i].images[0] + '" >\n            </div>\n\n            <div class="pv--15 padding__bottom--none product__item__content--container">\n              <div class="product__item__content--text flex fd--row jc--space__between width--100">\n                <h2 class="product__grid--title product--title fw--700 black ph--10 padding__left--none title">' + products[i].title + '</h2>\n                <div class="flex fd--row">\n                  <p class="product__grid--price product--title black price-grid">' + priceFinal + '<span class="product__grid--price-compare line__through product--title black" style="margin-left: 5px;">' + comparePriceFinal + '</span></p>\n                </div>\n              </div>\n            </div>\n\n  \n            <div class="product__item__div--hover flex fd--column">\n              <img class="image-hover margin__auto flex " loading="lazy" src="' + products[i].images[1] + '" >\n            </div>\n          </a>\n          </div>');

        if (products[i].compare_at_price != null) {
          var solde = products[i].price * -100 / products[i].compare_at_price + 100;
          var soldeFinal;
          if (solde < 52 && solde > 48) {
            soldeFinal = "-50%";
          } else if (solde < 32 && solde > 28) {
            soldeFinal = "-30%";
          } else if (solde < 22 && solde > 18) {
            soldeFinal = "-20%";
          } else if (solde < 12 && solde > 8) {
            soldeFinal = "-10%";
          }
          $('.product-reco' + i + ' .sales').text(soldeFinal);
        } else {
          $('.product-reco' + i + ' .sales__tag--container').hide();
          $('.product-reco' + i + ' .product__grid--price-compare').hide();
        }
      }
    } else {
      $('.four-product-reco-auto').hide();
    }
  });

  if (window.location.pathname.match(/^\/en/)) {
    $('.Matièreéco-responsable').text('Eco material');
    $('.Emballagerecyclé').text('Recycled packaging');
    $('.FabricationEuropéenne').text('European Union');
  }

  var numberColor = window.color.number;
  if (numberColor) {
    var _loop = function _loop(i) {
      $.ajax({
        url: '/products/' + window.color['product' + i],
        success: function success(result) {},
        error: function error(_error) {
          if (_error.status == 404) {
            $('.one-color-product[href=' + window.color['product' + i]).css('display', 'none');
          }
        }
      });
    };

    for (var i = 1; i <= numberColor; i++) {
      _loop(i);
    }
  }
}

var paques = window.general.paques;

function getDatePlusDays(dateString, days) {
  var parts = dateString.split('-');
  var date = new Date(new Date().getFullYear(), parts[0] - 1, parts[1]);
  date.setDate(date.getDate() + days);
  return ('' + (date.getMonth() + 1)).padStart(2, '0') + '-' + ('' + date.getDate()).padStart(2, '0');
}

var paquesMonday = getDatePlusDays(paques, 1);
var ascension = getDatePlusDays(paques, 39);
var pencote = getDatePlusDays(paques, 49);
var pencoteMonday = getDatePlusDays(paques, 50);

var fixedHolidays = ['01-01', // Jour de l'An
'05-01', // Fête du Travail
'05-08', // Victoire des Alliés 1945
'07-14', // Fête Nationale
'08-15', // Assomption
'11-01', // Toussaint
'11-11', // Armistice 1918
'12-25', // Noël
paques, paquesMonday, ascension, pencote, pencoteMonday];

function isHoliday(date) {
  var dayMonth = date.toISOString().slice(5, 10);
  return fixedHolidays.includes(dayMonth);
}

/*$(document).ready(function () {


  if (window.general.country == 'FR'){
    const now = new Date();
    //const now = new Date(2023, 10, 10, 16, 0);

    const dayOfWeek = now.getDay();
    const hour = now.getHours();
    //const hour = 16;
    //var dayOfWeek = 6

    function addDays(date, days) {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }

    // Utilisation de la fonction isHoliday pour vérifier si la date est un jour férié
    const isFerie = isHoliday(now);
    const deliveryDate = addDays(now, 3);
    var formattedDate
    if (window.general.langue == 'es'){
      formattedDate = deliveryDate.toLocaleDateString('es-ES', {day: 'numeric', month: 'long', year: 'numeric' });
    } else if (window.general.langue == 'fr'){
      formattedDate = deliveryDate.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
    } else {
      formattedDate = deliveryDate.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });
    }

    var ferieText = window.general.livraisonFerie.split("XXXX")

    if ((dayOfWeek >= 1 && dayOfWeek <= 5) && !isFerie) {
      if (dayOfWeek === 5 && hour > 14){
        $("#deliveryMessage").text(`${ferieText[0]} ${formattedDate} ${ferieText[1]}`);
      } else {
        $("#deliveryMessage").text(window.general.livraisonDemain);
      }
    } else if ((dayOfWeek === 5 && hour >= 15) || dayOfWeek === 6 || dayOfWeek === 0 || isFerie) {
      $("#deliveryMessage").text(`${ferieText[0]} ${formattedDate} ${ferieText[1]}`);
    }
  } else {
    $(".delivery--container").remove()
  }


});*/

$(document).ready(function () {
  if (window.general.country == 'FR') {
    var addDays = function addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    };

    var _isHoliday = function _isHoliday(date) {
      var dayMonth = date.toISOString().slice(5, 10);
      return fixedHolidays.includes(dayMonth);
    };

    var getNextTuesday = function getNextTuesday(date) {
      var nextTuesday = new Date(date);
      nextTuesday.setDate(date.getDate() + (9 - date.getDay()) % 7); // 9 is added to account for the days from current day to next Tuesday
      return nextTuesday;
    };

    // Vérifier si la date actuelle est un jour férié


    var now = new Date();
    //const now = new Date(2024, 3, 27, 16, 0);
    var dayOfWeek = now.getDay();
    var hour = now.getHours();

    console.log(now);

    var isFerie = _isHoliday(now);
    // Calculer la date de livraison J+3 pour les commandes du vendredi après 15h et les weekends
    //const deliveryDate = addDays(now, 4);
    var deliveryDate = getNextTuesday(now);
    var deliveryFerie = addDays(now, 2);
    var formattedDate, formattedFerie;

    // Formatage de la date selon la langue configurée
    if (window.general.langue == 'es') {
      formattedDate = deliveryDate.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' });
      formattedFerie = deliveryFerie.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' });
    } else if (window.general.langue == 'fr') {
      formattedDate = deliveryDate.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
      formattedFerie = deliveryFerie.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
    } else {
      formattedDate = deliveryDate.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });
      formattedFerie = deliveryFerie.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });
    }

    var ferieText = window.general.livraisonFerie.split("XXXX");

    if (dayOfWeek >= 1 && dayOfWeek <= 5 && !isFerie) {
      if (dayOfWeek === 5 && hour > 14) {
        $("#deliveryMessage").text(ferieText[0] + ' ' + formattedDate + ' ' + ferieText[1]);
      } else {
        $("#deliveryMessage").text(window.general.livraisonDemain);
      }
    } else if (isFerie) {
      $("#deliveryMessage").text(ferieText[0] + ' ' + formattedFerie + ' ' + ferieText[1]);
    } else if (dayOfWeek === 5 && hour >= 15 || dayOfWeek === 6 || dayOfWeek === 0) {
      $("#deliveryMessage").text(ferieText[0] + ' ' + formattedDate + ' ' + ferieText[1]);
    }
  } else {
    $(".delivery--container").remove();
  }
});

$(window).on('load', function () {
  console.log($('#country_code').val());
  if ($('#country_code').val() != 'FR') {
    console.log('passe');
    console.log($('#country_code').val());
  }
});

$('.click-gift').on('click', function () {
  $('.hidden-input--container').slideToggle(200);
  $('.button-add-product').toggleClass('giftCard');
});

$('body').on('click', '.button-autre-montant', function () {
  var link = $(this).attr('link');
  var nom = $('#nom-montant').val();
  var prenom = $('#prenom-montant').val();
  var montant = $('#montant-montant').val();
  var mailto = link.replace('xx', montant).replace('NOM', nom).replace('PRENOM', prenom);
  $('.button-autre-montant').attr('href', mailto);
  $('.button-autre-montant').click();
});

function toggleBuyBoxClass() {
  var button = $('.button-add-product');
  var buyBox = $('.product-sticky-buybox');
  var footerBanner = $('#bandeau--footer-slider');

  var selectSticky = $('.product-sticky-buybox .select__custom--values');
  var selectStickySelected = $('.product-sticky-buybox .select__custom--selected-value-container');

  var selectStickyBuybox = $('.product__description--fiche .select__custom--values');
  var selectStickySelectedBuybox = $('.product__description--fiche .select__custom--selected-value-container');

  var buttonOutOfView = !button.is(':visible') || button.offset().top + button.outerHeight() < $(window).scrollTop() || button.offset().top > $(window).scrollTop() + $(window).height();

  var footerInView = footerBanner.length && footerBanner.offset().top < $(window).scrollTop() + $(window).height() && footerBanner.offset().top + footerBanner.outerHeight() > $(window).scrollTop();

  if (footerInView) {
    console.log('close footer');
    buyBox.removeClass('opened');
    if (selectSticky.hasClass('opened')) {
      console.log('footer - remove');
      selectStickySelected.click();
    }
  } else if (buttonOutOfView) {
    buyBox.addClass('opened');
    if (selectStickyBuybox.hasClass('opened')) {
      console.log('Buybox - remove');
      selectStickySelectedBuybox.click();
    }
  } else {
    console.log('close else');
    buyBox.removeClass('opened');
    if (selectSticky.hasClass('opened')) {
      console.log('else - remove');
      selectStickySelected.click();
    }
  }
}

// Exécuter la fonction au scroll et à la redimension
$(window).on('scroll resize', function () {
  toggleBuyBoxClass();
});

// Exécuter la fonction lors du chargement de la page
toggleBuyBoxClass();

$('.product-sticky-buybox__add-to-cart').on('click', function () {
  console.log('passe ici');
  $('.add__to__cart--container .button-add-product').click();
});

$('.product-sticky-buybox__select .select-product').on('click', function () {
  var value = $(this).attr('value');
  $('.select__custom--value[value=' + value + ']').click();
});

$('#page__overlay--select-mobile, .product-sticky-buybox__close').on('click', function () {
  console.log('passe ici click');
  if ($('.product-sticky-buybox .select__custom--values').hasClass('opened')) {
    $('.product-sticky-buybox .select__custom--selected-value-container').click();
  }

  if ($('#page__overlay--select-mobile').hasClass('opened')) {
    $('#page__overlay--select-mobile').removeClass('opened');
  }
});
'use strict';

//footer
$(window).on('resize', function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('#sidebar-accordion-footer .extended-submenu').hide();
  }
});

// Gestion des boutons
$('.button__with__loading').on('click', function () {
  $(this).children('.button--text').hide();
  $(this).children('.button--loading').css('display', 'flex');
});

// Si go back --> on remet les boutons en mode texte
window.addEventListener("pageshow", function (event) {
  var historyTraversal = event.persisted || typeof window.performance != "undefined" && window.performance.navigation.type === 2;
  if (historyTraversal) {
    $('.button__with__loading').children('.button--text').show();
    $('.button__with__loading').children('.button--loading').css('display', 'none');
  }
});

$('.form--to-validate .form-field').on('invalid', function () {
  $('.form--to-validate .button--text').show();
  $('.form--to-validate .button--loading').css('display', 'none');
});

function deferSrcImages(className) {
  var imgDefer = document.getElementsByClassName(className);
  for (var i = 0; i < imgDefer.length; i++) {
    if (imgDefer[i].getAttribute('defer-src')) {
      imgDefer[i].setAttribute('src', imgDefer[i].getAttribute('defer-src'));
    }
  }
}

function deferSrcPoster(className) {
  var imgDefer = document.getElementsByClassName(className);
  for (var i = 0; i < imgDefer.length; i++) {
    if (imgDefer[i].getAttribute('defer-poster')) {
      imgDefer[i].setAttribute('poster', imgDefer[i].getAttribute('defer-poster'));
    }
  }
}

function deferSrcsetImages(className) {
  var imgDefer = document.getElementsByClassName(className);
  for (var i = 0; i < imgDefer.length; i++) {
    if (imgDefer[i].getAttribute('defer-srcset')) {
      imgDefer[i].setAttribute('srcset', imgDefer[i].getAttribute('defer-srcset'));
    }
  }
}

window.onload = function () {
  document.dispatchEvent(new CustomEvent('update-reco-drawer'));
  deferSrcsetImages("source--product");
  setTimeout(function () {
    deferSrcImages("defer--product");
    deferSrcImages('product__item__image');
  }, 200);
  if (window.matchMedia("(max-width: 767px)").matches) {}

  // Sur mobile, on rafraichit la hauteur des drawers au chargement
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('#cart__drawer, #drawer__cart--exta-infos, #navigation__drawer').css('height', window.innerHeight);
    $('#cart__drawer, #drawer__cart--exta-infos, #navigation__drawer').css('max-height', window.innerHeight);
  }

  if (document.referrer == "https://www.leonandharper.com/cart") {
    $('.button__action--cart-preview').click();
  }
};

// Gestion de la hauteur des drawers au scroll
$(document).on('scroll', function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('#cart__drawer, #drawer__cart--exta-infos, #navigation__drawer').css('height', window.innerHeight);
    $('#cart__drawer, #drawer__cart--exta-infos, #navigation__drawer').css('max-height', window.innerHeight);
  }
});

// Bloc SEO
$('#show').click(function () {
  $('.max__height--seo').css("max-height", '1000px');
  $(this).hide();
  $('#hide').show();
});
$('#hide').click(function () {
  $('.max__height--seo').css("max-height", '80px');
  $(this).hide();
  $('#show').show();
});

/*//Bloc slider home
if (window.matchMedia("(min-width: 950px)" ).matches) {
  $(window).on('load', function(){
      var heightFive = $('.products--container.five-products').outerHeight()

      var firstProductHeight = heightFive - 35
      console.log(firstProductHeight)
      $('.one-product.first .product__item__image').css('height', firstProductHeight)
  })
}*/

//newsletter
$('#form-footer, #form-home').on('submit', function (e) {
  console.log('passe form');
  e.preventDefault();
  if ($('#checkbox--newsletter').hasClass('checked')) {
    console.log('checked');
    $(this).unbind('submit').submit();
  } else {
    console.log('no checked');
    $('.text-error-confi').show();
    setTimeout(function () {
      $('.text-error-confi').hide();
    }, 4000);
  }
});

var pathname = window.location.pathname;
var langCode = pathname.split("/");
console.log(langCode[1]);
if (langCode[1] == 'en') {
  $('#logo__image--container, #homepage--link, .homepage-link').attr('href', '/en');
}
//langCode[1] - this will have your langauge code

$('body').on('click', '.product-reco-link--container', function (e) {
  gtag('event', 'cross_sell', {
    'product': $(this).find('.title').text(),
    'origin': productDetails.productTitle
  });
});

if (window.general.langue != 'fr') {
  $('#logo__image--container, #homepage--link').attr('href', '/' + window.general.langue);
}

$('#drawer-birthdate').on('input', function () {
  var input = $(this).val();
  var lastChar = input.slice(-1);

  // Ajouter '/' après le 2ème et le 5ème caractère
  if (input.length === 2 || input.length === 5) {
    $(this).val(input + '/');
  }
});

$('#drawer-birthdate').on('keydown', function (e) {
  var input = $(this).val();
  var selectionStart = this.selectionStart;

  if (e.key === 'Backspace') {
    if (selectionStart === 3 && input.charAt(selectionStart - 1) === '/') {
      var newInput = input.substring(0, selectionStart - 2) + input.substring(selectionStart);
      $(this).val(newInput);

      this.setSelectionRange(selectionStart - 2, selectionStart - 2);

      e.preventDefault();
    } else if (selectionStart === 6 && input.charAt(selectionStart - 1) === '/') {
      var newInput = input.substring(0, selectionStart - 2) + input.substring(selectionStart);
      $(this).val(newInput);

      this.setSelectionRange(selectionStart - 2, selectionStart - 2);

      e.preventDefault();
    }
  }
});

$('#create_customer').on('submit', function (e) {
  e.preventDefault();
  console.log('prevent submit');

  var birthday = $('#drawer-birthdate').val();

  function formatDate(date) {
    var parts = date.split('/');
    return parts[2] + '/' + parts[1] + '/' + parts[0];
  }

  var new_birthday = formatDate(birthday);
  $('#drawer-birthdate').val(new_birthday);

  console.log(new_birthday);

  $('#create_customer').unbind('submit').submit();
});
'use strict';

$('#go-top').on('click', function () {
  $('html, body').animate({
    scrollTop: 0
  }, 500);
});

if ($(document).scrollTop() > 20) {
  $('#go-top').show();
} else {
  $('#go-top').hide();
}

$(document).on('scroll', function () {
  if ($(document).scrollTop() > 20) {
    $('#go-top').show();
  } else {
    $('#go-top').hide();
  }
});
'use strict';

var displayPrice = function displayPrice(price) {
  return price / 100 + '€';
};
'use strict';

$('.newsletter-form').submit(function (e) {
  e.preventDefault();
  if ($('.checkbox--newsletter').hasClass('checked')) {
    console.log('is checked');
    $('.checkbox--email').hide();

    var index = $(this).attr('form-index');
    var email = $('.email--newsletter[form-index="' + index + '"]').val().toLowerCase();
    var fields = "$source,$email,$consent";

    var formData = {
      "email": email,
      "g": $('.list--newsletter[form-index="' + index + '"]').val(), // liste klaviyo
      "$consent": "email",
      "$source": $('.newsletter-form[form-index="' + index + '"]').attr('source'),
      "$fields": fields
    };

    $.ajax({
      type: "POST",
      url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
      data: formData,
      dataType: 'json',
      success: function success(response) {
        if (response.errors && response.errors.length > 0) {
          $('.newsletter-form .error--email').show();
          _learnq.push(['identify', {
            '$email': email
          }]);
        } else {
          $('.newsletter-form .success--email').show();
        }
      },
      error: function error(_error) {
        console.log(_error);
        $('.newsletter-form .error--email').show();
      }
    });
  } else {
    $('.checkbox--email').show();
  }
});

$('.checkbox-newsletter').on('click', function () {
  if ($(this).children('.checkbox--newsletter').hasClass('checked')) {
    $(this).children('.checkbox--newsletter').removeClass('checked');
  } else {
    $(this).children('.checkbox--newsletter').addClass('checked');
  }
});
'use strict';

$('body').on('click', '.atc', function () {
  var attribute = $(this).attr("data-atc");
  if (event.ctrlKey || $(this).hasClass('atc_blank')) {
    var newWindow = window.open(decodeURIComponent(window.atob(attribute)), '_blank');
    newWindow.focus();
  } else {
    document.location.href = decodeURIComponent(window.atob(attribute));
  }
});
'use strict';

$(document).ready(function () {
    var mobileBreakpoint = 768;

    $('.currency-selector').each(function () {
        var $popover = $(this);
        var $popoverButton = $popover.find('.js-popover-button');

        console.log($popoverButton);
        if ($popoverButton.length) {
            $popoverButton.on('click', function (event) {
                event.stopPropagation();
                $popover.toggleClass('visible');
            });
        }
    });

    $(document).on('click', function (event) {
        if (!$(event.target).closest('.currency-selector').length) {
            $('.currency-selector').removeClass('visible');
        }
    });
});

console.log('passe Nicolas');
});